import React, { Component, Fragment } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { SkyLightStateless } from 'react-skylight';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import ReactPaginate from 'react-paginate';
import { Field } from 'redux-form';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import {
  Grid, Row, Col, Panel, Button, ButtonToolbar, Breadcrumb, DropdownButton,
  MenuItem, Dropdown, Input,
} from 'react-bootstrap';
import { Translate, I18n } from 'react-redux-i18n';
import _, { debounce } from 'lodash';
import Dropzone from 'react-dropzone';

import GenericSelection from '../Common/GenericSelection';
import SpinnerButton from '../Common/SpinnerButton';
import ConfirmActionModal from '../Common/confirmActionModal';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import CashFormatter from '../Common/cashFormatter';
import { DateFormatter } from '../Common/dateFormat';
import { Selection } from '../Common/selection';
import { toFromDates } from '../Common/cleanDates';
import checkPermission from '../Common/permissions';
import genericRadioFilter from '../Common/genericRadioFilter';
import dateFilterRadios from '../Common/dateFilterRadios';
import { numberWithCommas } from '../Common/numberWithCommas';
import PurchaseManagementModals from '../Common/modals/purchaseManagement';
import Spinner from '../../components/Widgets/spinner';
import BolImagesTablePO from './components/BolImagesTablePO';
import ReceivingTable from './components/ReceivingTable';
import TypeRadios from '../../containers/Common/TypeRadios';
import GenericProductSuggest from '../../containers/Common/GenericProductSuggest';
import { ROOT_URL_V2, VENDOR_URL, PURCHASE_ORDERS_URL } from '../../actions/url';
import {
  ROOT_URL, ROOT_API_URL, companyCodeTitle, companyCode, isSH, isAP, isGGI, isLMH, isBRO,
  isSDR, isCRW, isOCM, isDAICHEONG, isHMM, isLAP, isAPD, isOLG, isVAK, isGFD, isSV, isABBLE,
  isEKC, isHO, isJRC, isCTP, isCCW, isSC
} from '../../actions/root_url';
import TrackingNoteModal from '../../containers/Purchase/trackingNoteModal';
import EmailContentModal from '../Sales/components/EmailContentModal';
import { getLocalStorageData } from '../../reducers/headerRedux';
import { fileDownload, getKeysMap, getSortVal } from '../../utils';
import { PURCHASE_ORDER_FILTER_KEY_OBJ, PURCHASE_ORDER_SORT_KEY_OBJ, AP_PURCHASE_ORDER_FILTER_KEY_OBJ } from '../../utils/map';

const {
  MergePOModal,
  SplitPOModal,
  ConvertToSOModal,
} = PurchaseManagementModals;
const isJML = ROOT_API_URL === "https://jml-scm.truckxi.com/api/" || ROOT_URL === "https://jml-scm.truckxi.com/api/";
const isAFGRelated =  (ROOT_URL === "https://afg-scm.truckxi.com/api/" || ROOT_URL === "https://afgstage-scm.truckxi.com/api/" || ROOT_URL === "https://mmdavis-scm.truckxi.com/api/");
const isAFG = ROOT_API_URL === 'https://afg-scm.truckxi.com/api/' || ROOT_URL === 'https://afgstage-scm.truckxi.com/api/';
const isMMD = ROOT_API_URL === 'https://mmdavis-scm.truckxi.com/api/' || ROOT_URL === 'https://mmdavis-scm.truckxi.com/api/';
const isMyuMyu = ROOT_API_URL === 'https://mmstage-scm.truckxi.com/api/' || ROOT_API_URL === 'https://myumyu-scm.truckxi.com/api/';
const isTN = ROOT_API_URL === 'https://tn-scm.truckxi.com/api/' || ROOT_URL === 'https://tn-scm.truckxi.com/api/';
const isPS = ROOT_API_URL === 'https://premiumstella-scm.truckxi.com/api/' || ROOT_URL === 'https://premiumstella-scm.truckxi.com/api/';
const isUSPride = ROOT_API_URL === 'https://uspride-scm.truckxi.com/api/' || ROOT_URL === 'https://uspride-scm.truckxi.com/api/';

const ROWS_FILTER_BY_API_KEYS = ['PONum', 'VendorID', 'VendorName', 'container_num', 'Purchaser_User_Name']

const propTypes = {
  setDefaultDays: PropTypes.func.isRequired,
  setDefaultOfForm: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  resetCurrentPurchaseOrder: PropTypes.func.isRequired,
  selectPurchaseOrder: PropTypes.func.isRequired,
  clearCheckPassword: PropTypes.func.isRequired,
  checkPassword: PropTypes.func.isRequired,
  deletePurchaseOrder: PropTypes.func.isRequired,
  checkPasswordFailure: PropTypes.func.isRequired,
  fetchPurchaseOrdersByFilter: PropTypes.func.isRequired,
  fetchBaseUsers: PropTypes.func.isRequired,
  printPurchaseOrder: PropTypes.func.isRequired,
  setPurchaseOrdersFilter: PropTypes.func.isRequired,
  fetchPurchaseOrderList: PropTypes.func.isRequired,
  resetStatus: PropTypes.func.isRequired,
  purchaseOrdersFilter: PropTypes.object.isRequired,
  checkPasswordSuccess: PropTypes.bool.isRequired,
  purchaseOrders: PropTypes.array.isRequired,
  ProductNum: PropTypes.string.isRequired,
  FromDate: PropTypes.string.isRequired,
  ToDate: PropTypes.string.isRequired,
  requestingPurchaseOrderPdf: PropTypes.bool.isRequired,
  purchaseOrderListIsLoading: PropTypes.bool.isRequired,
  purchaseOrderListError: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  error: PropTypes.bool.isRequired,
  users: PropTypes.array.isRequired,
  usersIsLoading: PropTypes.bool.isRequired,
  Status: PropTypes.string.isRequired,
  Purchaser: PropTypes.object.isRequired,
  Days: PropTypes.string.isRequired,
  purchaseOrderPdf: PropTypes.object.isRequired,
  purchaseOrderList: PropTypes.array.isRequired,
  ShipFromDate: PropTypes.string.isRequired,
  ShipToDate: PropTypes.string.isRequired,
};

class PurchaseOrderList extends Component {
  static contextTypes = {
    router: React.PropTypes.object,
  };

  constructor() {
    super();
    this.state = {
      clear: true,
      showTrackingNoteModal: false,

      rows: [],
      selectedRows: [],
      filters: {},
      searchFilters: {},
      sortColumn: null,
      sortDirection: null,

      purchaseOrderDetail: {
        rows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },

      podImageRows: {
        rows: [],
        // filters: {},
        // sortColumn: null,
        // sortDirection: null,
        selectedRows: [],
      },

      emailContentModalVisibility: false,
      emailSubjectTemplate: '',
      emailContentTemplate: '',

      suggestValue: '',
      productSearchType: 'ProductNum',
      days: isOLG ? '1' : '7',
      filteredByItem: false,
      currencyCode: '',
      checkAuthorizeOpen: false,
      action: null,

      // for generic radiofilter and datePicker
      FromDate: undefined,
      ToDate: undefined,
      Status: 'all',
      filterProductID: 0,
      PdfFrameLoaded: true,
      PdfFrameLoadedNs: true,
      commercialInvoicePdfFrameLoaded: true,
      packingListPdfFrameLoaded: true,
      orderIds: [],
      validMerge: true,
      mergeModalOpen: false,
      isSearchingRelocated: false,
      Type: null,
      showTotalBoxesPrintDialog: false,
      totalBoxesDialogType: null,
      isMergePOModalVisible: false,
      isSplitPOModalVisible: false,
      currentPage: (isOCM || isVAK) ? 0 : undefined,
      limit: (isOCM || isVAK) ? 30 : isOLG ? 50 : (isSH || isAP) ? 10 : undefined,
      limitDisplay: (isOCM || isVAK) ? '30' : isOLG ? '50' : (isSH || isAP) ? '10' : '30',
      submitImageOpen: false,
      managePodOpen: false,
      duplicateOpen: false,
      selectedVendor: null,
      vendorOptions: [],
      apiSortInfo: {
        sortColumn: null,
        sortDirection: null,
      },
      rowsCount: 0,
      canceledOrders: 0,
      total: 0,
      canceledTotal: 0,
      totalQty: 0,
      totalCancelledQty:0,
      totalNetWeight: 0,

      containerNumOpen: false,
      containerNum: null,

      //ship date filter for Abble
      // days: '7'
      ShipFromDate: undefined,
      ShipToDate: undefined,
      setOrderLoading: false,

      editReceivingOpen: false,
      editReceivingPoNum: null,
      editReceivingPoId: null,
    };

    this.fetchPurchaseOrdersByDetails = this.fetchPurchaseOrdersByDetails.bind(this);
    this.checkAuthorize = this.checkAuthorize.bind(this);
    this.openCheckAuthorize = this.openCheckAuthorize.bind(this);
    this.closeCheckAuthorize = this.closeCheckAuthorize.bind(this);
  }

  componentWillMount() {
    this.props.setDefaultDays('purchaseOrderList');
    this.props.setDefaultOfForm('Status', 'all', 'purchaseOrderList');
  }

  componentDidMount() {
    if (((isEKC || isLMH || isBRO || isSDR || isCRW || isSC) && (this.context.router.routes[1].path === "dropshipOrder"))) {
      this.state.Type = 'Open';
      // this.setState({Type: 'Open'});
    }
    document.title = companyCodeTitle;
    const { purchaseOrdersFilter } = this.props;
    if (purchaseOrdersFilter) {
      const selectedRows = purchaseOrdersFilter.currentRows.filter(r => r.isSelected);
      this.setState({ rows: purchaseOrdersFilter.currentRows, selectedRows, filters: {} });
      this.props.setValue('purchaseOrderList', 'Days', purchaseOrdersFilter.Days);
      this.props.setValue('purchaseOrderList', 'FromDate', purchaseOrdersFilter.FromDate);
      this.props.setValue('purchaseOrderList', 'ToDate', purchaseOrdersFilter.ToDate);
      this.props.setValue('purchaseOrderList', 'Purchaser', purchaseOrdersFilter.Purchaser);
      this.props.setValue('purchaseOrderList', 'Status', purchaseOrdersFilter.Status);
      this.props.setValue('purchaseOrderList', 'ProductNum', purchaseOrdersFilter.ProductNum);

      this.props.setValue('purchaseOrderList', 'ShipFromDate', purchaseOrdersFilter.ShipFromDate);
      this.props.setValue('purchaseOrderList', 'ShipToDate', purchaseOrdersFilter.ShipToDate);
      let fromDate = '1900-01-01';
      if (purchaseOrdersFilter.FromDate) {
        fromDate = this.formatDate(purchaseOrdersFilter.FromDate);
      }
      let toDate = '3000-01-01';
      if (purchaseOrdersFilter.ToDate) {
        toDate = this.formatDate(purchaseOrdersFilter.ToDate);
      }

      let shipFromDate = '1900-01-01';
      if (purchaseOrdersFilter.ShipFromDate) {
        shipFromDate = this.formatDate(purchaseOrdersFilter.ShipFromDate);
      }
      let shipToDate = '3000-01-01';
      if (purchaseOrdersFilter.ShipToDate) {
        shipToDate = this.formatDate(purchaseOrdersFilter.ShipToDate);
      }

      let purchaser = purchaseOrdersFilter.Purchaser;
      if (purchaseOrdersFilter.Purchaser) {
        purchaser = purchaseOrdersFilter.Purchaser.value;
      }
      if (isOCM) {
        this.state.currentPage = 0;
      }
      this.props.fetchPurchaseOrdersByFilter(
        this.context.router.routes[1].path,
        fromDate,
        toDate,
        purchaseOrdersFilter.Days,
        purchaseOrdersFilter.Status,
        purchaser,
        purchaseOrdersFilter.ProductNum,
        shipFromDate,
        shipToDate,
        this.state.Type,
        undefined,
        this.state.productSearchType,
        undefined,
        undefined,
        this.state.limit,
        this.state.currentPage,
        this.getFilterParams(),
        isVAK,
      );
      this.props.fetchBaseUsers();
    } else {
      const fromDate = '1900-01-01';
      const toDate = '3000-01-01';
      const shipFromDate = '1900-01-01';
      const shipToDate = '3000-01-01';
      const days = isOLG ? 1 : 7;
      let status = 'all';

      if (this.context.router.routes[1].path === "purchaseOrderQuote") {
        // HKGF PurchaseOrder Quote
        this.setState({
          isPurchaseOrderQuote: true,
          Status: 'Quote'
        });
        status = 'Quote';
      }

      this.props.setDefaultDays('purchaseOrderList');
      this.props.setDefaultOfForm('Status', status, 'purchaseOrderList');
      if (isOCM) {
        this.state.currentPage = 0;
      }
      this.props.fetchPurchaseOrdersByFilter(
        this.context.router.routes[1].path,
        fromDate,
        toDate,
        days,
        status,
        null,
        null,
        shipFromDate,
        shipToDate,
        this.state.Type,
        undefined,
        this.state.productSearchType,
        undefined,
        undefined,
        this.state.limit,
        this.state.currentPage,
        this.getFilterParams(),
        isVAK,
      );
      this.props.fetchBaseUsers();
    }
  }

  // Once products are ready, reset state.
  componentDidUpdate(prevProps, prevState) {
    if ((isGGI || isABBLE || isCCW) && prevState.filters != this.state.filters) {
      this.handleSumTotal(Data.Selectors.getRows(this.state))
    }
    if ((isGGI || isABBLE || isCCW) && this.state.selectedRows && prevState.selectedRows.length != this.state.selectedRows.length && this.state.selectedRows.length != 0) {
      this.handleSumTotal(this.state.selectedRows, true);
    }

    if ((isGGI || isABBLE || isCCW) && this.state.selectedRows && prevState.selectedRows.length != this.state.selectedRows.length && this.state.selectedRows.length == 0) {
      this.handleSumTotal(this.state.rows, true);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedWarehouse !== this.props.selectedWarehouse && nextProps.selectedWarehouse.value) {
      if (isLMH || isBRO || isSDR || isCRW || isSC) {
        this.closeDuplicate();
        setTimeout(() => {
          this.setState({selectedRows: [], selectedVendor: null});
        }, 500);
      }
      this.props.fetchBaseUsers();
      this.refreshList();
    }
    if (nextProps.checkPasswordSuccess && nextProps.checkPasswordSuccess !== this.props.checkPasswordSuccess) {
      this.closeCheckAuthorize();
      if (this.state.action === 'void') {
        this.deletePurchaseOrder();
      }
    }
    if (nextProps.purchaseOrders && nextProps.purchaseOrders !== this.props.purchaseOrders) {
      if (this.props.purchaseOrdersFilter && this.props.purchaseOrdersFilter.currentRows) {
        const { purchaseOrders } = nextProps;
        let rows = [...this.state.rows];
        rows = rows.map((r) => {
          const index = _.findIndex(purchaseOrders, { PurchaseOrder_id: r.PurchaseOrder_id });
          if (index > -1) {
            r.ETADate = purchaseOrders[index].ETADate;
          } else {
            r = null;
          }
          return r;
        });
        rows = rows.filter(r => r !== null);
        this.handleSumTotal(rows);
        const purchaseOrderDetail = { ...this.state.purchaseOrderDetail, rows: this.props.purchaseOrderList };
        this.setState({ rows, purchaseOrderDetail });
        this.props.setPurchaseOrdersFilter(null);
      } else {
        const rows = nextProps.purchaseOrders;
        if (rows && rows.length !== 0) {
          rows.map((row) => {
            if(isGGI) {
              row.Dropship = row.is_transloading ? 'yes' : 'no';
            } else {
              row.Dropship = row.IsDropship ? 'yes' : 'no';
            }
          });
        }
        this.handleSumTotal(rows)
        const purchaseOrderDetail = { ...this.state.purchaseOrderDetail, rows: [] };
        this.setState({ rows, purchaseOrderDetail });
        this.props.setPurchaseOrdersFilter(null);
      }
    }

    if (nextProps.purchaseOrderList && nextProps.purchaseOrderList !== this.props.purchaseOrderList) {
      const purchaseOrderDetail = { ...this.state.purchaseOrderDetail, rows: nextProps.purchaseOrderList };
      this.setState({ purchaseOrderDetail });
    }

    if (nextProps.Status && nextProps.Status !== this.props.Status) {
      const { purchaseOrdersFilter } = this.props;
      if (!purchaseOrdersFilter) {
        let purchaser = this.props.Purchaser;
        if (this.props.Purchaser) {
          purchaser = this.props.Purchaser.value;
        }
        const fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
        const toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
        let { days } = this.state;
        if (days == null) {
          days = 7;
        }

        const shipFromDate = this.state.ShipFromDate ? this.formatDate(this.state.ShipFromDate) : '1900-01-01';
        const shipToDate = this.state.ShipToDate ? this.formatDate(this.state.ShipToDate) : '3000-01-01';

        const productNum = this.props.ProductNum;
        if (isOCM) {
          this.state.currentPage = 0;
        }
        this.props.fetchPurchaseOrdersByFilter(
          this.context.router.routes[1].path,
          fromDate,
          toDate,
          days,
          nextProps.Status,
          purchaser,
          productNum,
          shipFromDate,
          shipToDate,
          this.state.Type,
          undefined,
          this.state.productSearchType,
          undefined,
          undefined,
          this.state.limit,
          this.state.currentPage,
          this.getFilterParams(),
          isVAK,
        );
      }
    }

    if (nextProps.Purchaser && nextProps.Purchaser !== this.props.Purchaser) {
      const { purchaseOrdersFilter } = this.props;
      if (!purchaseOrdersFilter) {
        let purchaser = nextProps.Purchaser;
        if (nextProps.Purchaser) {
          purchaser = nextProps.Purchaser.value;
        }
        const fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
        const toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
        const { days } = this.state;

        const shipFromDate = this.state.ShipFromDate ? this.formatDate(this.state.ShipFromDate) : '1900-01-01';
        const shipToDate = this.state.ShipToDate ? this.formatDate(this.state.ShipToDate) : '3000-01-01';

        const productNum = this.props.ProductNum;
        if (isOCM) {
          this.state.currentPage = 0;
        }
        this.props.fetchPurchaseOrdersByFilter(
          this.context.router.routes[1].path,
          fromDate,
          toDate,
          days,
          this.state.Status,
          purchaser,
          productNum,
          shipFromDate,
          shipToDate,
          this.state.Type,
          undefined,
          this.state.productSearchType,
          undefined,
          undefined,
          this.state.limit,
          this.state.currentPage,
          this.getFilterParams(),
          isVAK,
        );
      }
    }

    if (this.props.Purchaser && nextProps.Purchaser == null) {
      const purchaser = nextProps.Purchaser;
      const fromDate = this.props.FromDate ? this.formatDate(this.props.FromDate) : '1900-01-01';
      const toDate = this.props.ToDate ? this.formatDate(this.props.ToDate) : '3000-01-01';
      const days = this.props.Days;
      const shipFromDate = this.props.ShipFromDate ? this.formatDate(this.props.ShipFromDate) : '1900-01-01';
      const shipToDate = this.props.ShipToDate ? this.formatDate(this.props.ShipToDate) : '3000-01-01';
      const productNum = this.props.ProductNum;
      if (isOCM) {
        this.state.currentPage = 0;
      }
      this.props.fetchPurchaseOrdersByFilter(
        this.context.router.routes[1].path,
        fromDate,
        toDate,
        days,
        this.props.Status,
        purchaser,
        productNum,
        shipFromDate,
        shipToDate,
        this.state.Type,
        undefined,
        this.state.productSearchType,
        undefined,
        undefined,
        this.state.limit,
        this.state.currentPage,
        this.getFilterParams(),
        isVAK,
      );
    }

    if (nextProps.Days && nextProps.Days !== this.props.Days) {
      if (nextProps.Days !== -1) {
        this.props.setDefaultOfForm('FromDate', null, 'purchaseOrderList');
        this.props.setDefaultOfForm('ToDate', null, 'purchaseOrderList');
      }
      this.setState({ days: nextProps.Days });
    }

    if (nextProps.purchaseOrderPdf && nextProps.purchaseOrderPdf !== this.props.purchaseOrderPdf) {
      if ((isLAP || isAPD) && this.state.selectedRows && this.state.selectedRows.length > 0) {
        fileDownload(nextProps.purchaseOrderPdf, this.state.selectedRows[0].PONum);
      } else {
      this.setState({ PdfFrameLoaded: false });
      }
    }

    if (nextProps.purchaseOrderPdfNs && nextProps.purchaseOrderPdfNs !== this.props.purchaseOrderPdfNs) {
      if ((isLAP || isAPD) && this.state.selectedRows && this.state.selectedRows.length > 0) {
        fileDownload(nextProps.purchaseOrderPdfNs, this.state.selectedRows[0].PONum);
      } else {
        this.setState({ PdfFrameLoadedNs: false });
      }
    }

    if (nextProps.commercialInvoicePdf && nextProps.commercialInvoicePdf !== this.props.commercialInvoicePdf) {
      this.setState({commercialInvoicePdfFrameLoaded: false});
    }

    if(nextProps.packingListPdf && nextProps.packingListPdf !== this.props.packingListPdf) {
      this.setState({packingListPdfFrameLoaded: false});
    }

    if (typeof this.props.FromDate !== 'undefined' && typeof this.props.ToDate !== 'undefined' && (nextProps.FromDate !== this.props.FromDate || nextProps.ToDate !== this.props.ToDate)) {
      let FromDate;
      let ToDate;
      let purchaser = this.props.Purchaser;
      if (nextProps.FromDate != null) {
        FromDate = this.formatDate(nextProps.FromDate);
      }
      if (nextProps.ToDate != null) {
        ToDate = this.formatDate(nextProps.ToDate);
      }
      if (this.props.Purchaser) {
        purchaser = this.props.Purchaser.value;
      }
      if (isOCM) {
        this.state.currentPage = 0;
      }
      this.props.fetchPurchaseOrdersByFilter(
        this.context.router.routes[1].path,
        FromDate,
        ToDate,
        -1,
        this.props.Status,
        purchaser,
        this.state.filterProductID,
        this.formatDate(nextProps.ShipFromDate),
        this.formatDate(nextProps.ShipToDate),
        this.state.Type,
        undefined,
        this.state.productSearchType,
        undefined,
        undefined,
        this.state.limit,
        this.state.currentPage,
        this.getFilterParams(),
        isVAK,
      );
    }

    if (nextProps.mergePurchaseOrderSuccess && nextProps.mergePurchaseOrderSuccess !== this.props.mergePurchaseOrderSuccess) {
      this.cancelMergeRequest();
      const fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
      const toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
      let { days } = this.state;
      if (days == null) {
        days = 7;
      }

      const shipFromDate = this.state.ShipFromDate ? this.formatDate(this.state.ShipFromDate) : '1900-01-01';
      const shipToDate = this.state.ShipToDate ? this.formatDate(this.state.ShipToDate) : '3000-01-01';

      let purchaser = this.props.Purchaser;
      if (this.props.Purchaser) {
        purchaser = this.props.Purchaser.value;
      }
      const productNum = this.props.ProductNum;
      if (isOCM) {
        this.state.currentPage = 0;
      }
      this.props.fetchPurchaseOrdersByFilter(
        this.context.router.routes[1].path,
        fromDate,
        toDate,
        days,
        nextProps.Status,
        purchaser,
        productNum,
        shipFromDate,
        shipToDate,
        this.state.Type,
        undefined,
        this.state.productSearchType,
        undefined,
        undefined,
        this.state.limit,
        this.state.currentPage,
        this.getFilterParams(),
        isVAK,
      );
    }

    if (nextProps.mergePurchaseOrderError && nextProps.mergePurchaseOrderError !== this.props.mergePurchaseOrderError) {
      this.cancelMergeRequest();
      alert(nextProps.mergePurchaseOrderError)
    }

    if (nextProps.currentPage && nextProps.currentPage !== this.props.currentPage) {
      this.setState({ currentPage: nextProps.currentPage });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextState.PdfFrameLoaded !== this.state.PdfFrameLoaded && !this.state.PdfFrameLoaded) {
      return false;
    }
    if (nextState.PdfFrameLoadedNs !== this.state.PdfFrameLoadedNs && !this.state.PdfFrameLoadedNs) {
      return false;
    }
    if (nextState.commercialInvoicePdfFrameLoaded !== this.state.commercialInvoicePdfFrameLoaded && !this.state.commercialInvoicePdfFrameLoaded) {
      return false;
    }
    if (nextState.packingListPdfFrameLoaded !== this.state.packingListPdfFrameLoaded && !this.state.packingListPdfFrameLoaded) {
      return false;
    }

    return true;
  }

  componentWillUnmount() {
    if (this.state.clear) {
      this.props.setPurchaseOrdersFilter(null);
    }
  }

  // Used for new generic datePicker
  setToDate = (e) => {
    if (e < this.state.FromDate) { return; }
    this.setState({ ToDate: e });
  };

  setFromDate = (e) => {
    if (e > this.state.ToDate) { return; }
    this.setState({ FromDate: e });
  };

  setToRangeSearch = () => {
    this.setState({ days: '-1' });
  };

  handleOptionChange = (changeEvent) => {
    this.setState({ productSearchType: changeEvent.target.value });
  };

  handleRelocatedSearchCheckClick = (e) => {
    this.setState({
      isSearchingRelocated: !this.state.isSearchingRelocated,
    });
  }

  // ship date filter for Abble
  setShipToDate = (e) => {
    if (e === null ) {
      this.setState({ ShipToDate: undefined });
      return;
    }
    if (e < this.state.ShipFromDate) {
      return;
    }
    this.setState({ ShipToDate: e });
  };

  setShipFromDate = (e) => {
    if (e === null) {
      this.setState({ ShipFromDate: undefined });
      return;
    }
    if (e > this.state.ShipToDate) {
      return;
    }
    this.setState({ ShipFromDate: e });
  };

  checkAuthorize(password) {
    this.props.checkPassword(password);
  }
  openCheckAuthorize(action) {
    this.props.clearCheckPassword();
    this.setState({ checkAuthorizeOpen: true, action });
  }
  closeCheckAuthorize() {
    this.setState({ checkAuthorizeOpen: false });
  }

  // sunset add container num
  openAddContainerNum() {
    this.setState({
      containerNumOpen: true,
      containerNum: null,
    });
  }
  closeAddContainerNum() {
    this.setState({ containerNumOpen: false });
  }
  onChangeContainerNum = (e) => {
    this.setState({ containerNum: e.target.value });
  };
  confirmContainerNum = () => {
    const { selectedRows } = this.state;
    const pks = selectedRows.map(r => r.id);
    let data = {
      container_num: this.state.containerNum,
    };

    axios.post(
      `${ROOT_URL}v2/purchase/add_container_num/${pks.join(',')}`,
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    ).then((response) => {
      alert("Contaoner No. Added");
      this.closeAddContainerNum();
      this.refreshList();
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
      }
      alert(JSON.stringify(err.data));
    });
  };


  formatDate(date) {
    let formattedDate = `${date.getFullYear()}-`;

    formattedDate += `${date.getMonth() + 1}-`;
    if (date.getDate() < 10) {
      formattedDate += `0${date.getDate()}`;
    } else {
      formattedDate += date.getDate();
    }

    return formattedDate;
  }

  // Set product being selected to be currentProduct and navigate user to the edit page

  setCurrentPurchaseOrder(e) {
    e.preventDefault();
    this.setState({ clear: false });
    const currentPurchaseOrder = this.state.selectedRows[0];
    const { FromDate, ToDate, ShipFromDate, ShipToDate} = this.props;
    this.props.resetCurrentPurchaseOrder();
    this.props.selectPurchaseOrder(currentPurchaseOrder);
    const currentRows = Data.Selectors.getRows(this.state);
    this.props.setPurchaseOrdersFilter({
      Days: this.props.Days,
      FromDate,
      ToDate,
      Status: this.props.Status,
      Purchaser: this.props.Purchaser,
      ProductNum: this.props.ProductNum,
      currentRows,
      ShipFromDate,
      ShipToDate,
    });
    this.context.router(`/purchaseOrder/${currentPurchaseOrder.PurchaseOrder_id}`);
  }

  printPurchaseOrder(e) {
    e.preventDefault();
    const currentPurchaseOrder = this.state.selectedRows[0];
    this.props.printPurchaseOrder(currentPurchaseOrder.PurchaseOrder_id);
  }

  deletePurchaseOrder() {
    // e.preventDefault();
    const currentPurchaseOrder = this.state.selectedRows[0];
    if((isLAP || isAPD) || isGFD) {
      let current = [...this.state.selectedRows];
      let ids = current.map(item => {
        return item.PurchaseOrder_id;
      })
      this.props.deletePurchaseOrder(ids.toString());
      return
    }
    this.props.deletePurchaseOrder(currentPurchaseOrder.PurchaseOrder_id);
  }

  shouldEditButtonDisable() {
    const { selectedRows } = this.state;

    // has DropshipFrom -> can't edit
    if (isGFD) {
       if (selectedRows[0].DropshipFrom !== null) {
         return true;
       }
    }
    return false;
  }

  shouldVoidButtonDisable() {
    const { selectedRows } = this.state;

    // Always disable void if selected more than 1 row
    if (selectedRows === null || (!(isLAP || isAPD) && selectedRows.length !== 1 || (isLAP || isAPD) && selectedRows.length == 0)) {
      return true;
    }

    const status = selectedRows[0] ? selectedRows[0].PurchaseStatus : 'disable';
    let disabled = (!(isLAP || isAPD) && (status !== 'Placed' && status !== 'Departed') || (isLAP || isAPD) && (status !== 'Placed' && status != 'Draft')) || status === 'disable';
    if ((isMMD || isAFG) && (status === 'Pending' || status === 'Merged')) {
      disabled = false;
    }
    if (isVAK) {
      if (status === 'Pending' || status === 'Placed') {
        disabled = false;
      }
    }

    // has DropshipFrom -> can't void
    if (isGFD) {
       if (selectedRows[0].DropshipFrom !== null) {
         disabled = true;
       }
    }
    return disabled;
  }

  shouldVoidButtonDisableMulti() {
    const { selectedRows } = this.state;

    if (selectedRows === null || selectedRows.length === 0) {
      return true;
    }

    let disabled = false;

    selectedRows.map((r,i) => {
      if (r.DropshipFrom !== null) {
        disabled = true;
        return;
      }
      if (r.PurchaseStatus === 'Placed' || r.PurchaseStatus === 'Departed' || r.PurchaseStatus === 'Draft') {

      } else {
        disabled = true;
        return;
      }
    });

    // has DropshipFrom -> can't void
    // if (isGFD) {
    //    if (selectedRows[0].DropshipFrom !== null) {
    //      disabled = true;
    //    }
    // }
    return disabled;
  }

  submitApprovePO(selectedRows) {
    let output = [];
    selectedRows.map(r=>{
      output.push(r.id);
    });
    this.props.approvePendingPO(output)
      .then((response) => {
        alert('PO Approved');
        this.refreshList();
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        alert('Error: ' + err.data);
      });
  }

  submitSetToDraft(selectedRows) {
    let output = [];
    selectedRows.map(r=>{
      output.push(r.id);
    });
    this.props.setDraftToOpen(output.join(','))
      .then((response) => {
        alert('Set Placed Success');
        this.refreshList();
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        alert('Error: ' + err.data);
      });
  }

  genSubjectTemplate = () => {
      const row = this.state.selectedRows[0];
      const activeCompany = getLocalStorageData('selectedCompany').label;
      if(row) {
        const poNum = row.PONum;
        return `Purchase Order ${poNum} from ${activeCompany.toUpperCase()}`
      }

    return ''
  }

  genContentTemplate = () => {
      const activeCompany = getLocalStorageData('selectedCompany').label;
      return `Dear Vendor:

Our purchase order is attached. Please review and confirm.
Thank you for your business - we appreciate very much

Sincerely, 
${(isLAP || isAPD) ? 'LAP INTERNATIONAL.' : activeCompany.toUpperCase()}.`
  }

  handleEmailContentClose = () => {
    this.setState({
      emailContentModalVisibility: false,
      emailSubjectModalTemplate: '',
      emailContentModalTemplate: ''
    })
  }

  handleEmailContentConfirm = (subject, content, email, phone, sendEmail, source) => {
    const row = this.state.selectedRows[0];
    if(row) {
      this.props.emailPOPost(row.PurchaseOrder_id, subject, content, email, phone, sendEmail, source);
      this.handleEmailContentClose();
    }
  }

  refreshList(clearSelectedRow = false) {
    // const { purchaseOrdersFilter } = this.props;
    let { selectedRows } = this.state;
    let newRows = this.state.rows;
    const fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
    const toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
    let { days } = this.state;
    if (days == null) {
      days = 7;
    }

    const shipFromDate = this.state.ShipFromDate ? this.formatDate(this.state.ShipFromDate) : '1900-01-01';
    const shipToDate = this.state.ShipToDate ? this.formatDate(this.state.ShipToDate) : '3000-01-01';

    let purchaser = this.props.Purchaser;
      if (this.props.Purchaser) {
        purchaser = this.props.Purchaser.value;
      }
    const productNum = this.props.ProductNum;
    if (isOCM) {
      this.state.currentPage = 0;
    }
    this.props.fetchPurchaseOrdersByFilter(
      this.context.router.routes[1].path,
      fromDate,
      toDate,
      days,
      this.state.Status,
      purchaser,
      productNum,
      shipFromDate,
      shipToDate,
      this.state.Type,
      this.state.suggestValue,
      this.state.productSearchType,
      undefined,
      undefined,
      this.state.limit,
      this.state.currentPage,
      this.getFilterParams(),
      isVAK,
    );

    if (clearSelectedRow) {
      this.setState({
        selectedRows: [],
      })
    } else {
      setTimeout(() => {
        newRows = this.state.rows;
        if (newRows) {
          newRows.map((r, i)=>{
            selectedRows.map((s, j)=>{
              if (r.id === s.id) {
                selectedRows[j] = r;
                newRows[i].isSelected = true;
              }
            });
          });
        }
        this.setState({ ...this.state, selectedRows, rows: newRows});
      }, 1000);
    }
  }

  clickNew(e) {
    e.preventDefault();
    this.props.resetCurrentPurchaseOrder();
    this.context.router.push('/purchaseOrder/new');
  }

  renderUsers() {
    if (this.props.usersIsLoading) return <Spinner />; // If group is loading, show a spinner.

    const Users = this.getUsers();
    return (
      <div className="control-dropdown">
        <Field name="Purchaser" component={Selection} options={Users} />
      </div>
    );
  }

  getUsers() {
    const Users = [];
    this.props.users.map((user) => {
      Users.push({ value: user.user_id, label: user.username });
    });
    return Users;
  }

  handleStatusFilterChange = (status) => {
    const { purchaseOrdersFilter } = this.props;
    if (!purchaseOrdersFilter) {
      let purchaser = this.props.Purchaser;
      if (this.props.Purchaser) {
        purchaser = this.props.Purchaser.value;
      }
      const fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
      const toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
      let { days } = this.state;
      if (days == null) {
        days = 7;
      }
      const shipFromDate = this.state.ShipFromDate ? this.formatDate(this.state.ShipFromDate) : '1900-01-01';
      const shipToDate = this.state.ShipToDate ? this.formatDate(this.state.ShipToDate) : '3000-01-01';
      const productNum = this.props.ProductNum;
      this.setState({ Status: status }, () => {
        if (isOCM) {
          this.state.currentPage = 0;
        }
        this.props.fetchPurchaseOrdersByFilter(
          this.context.router.routes[1].path,
          fromDate,
          toDate,
          days,
          this.state.Status,
          purchaser,
          productNum,
          shipFromDate,
          shipToDate,
          this.state.Type,
          undefined,
          this.state.productSearchType,
          undefined,
          undefined,
          this.state.limit,
          this.state.currentPage,
          this.getFilterParams(),
          isVAK,
        );
      });
    } else {
      this.setState({ Status: status });
    }
  };

  handleTypeFilterChange = (Type) => {
    let purchaser = this.props.Purchaser;
    if (this.props.Purchaser) {
      purchaser = this.props.Purchaser.value;
    }
    const fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
    const toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
    let { days } = this.state;
    if (days == null) {
      days = 7;
    }
    const shipFromDate = this.state.ShipFromDate ? this.formatDate(this.state.ShipFromDate) : '1900-01-01';
    const shipToDate = this.state.ShipToDate ? this.formatDate(this.state.ShipToDate) : '3000-01-01';
    const productNum = this.props.ProductNum;
    this.setState({ Type }, () => {
      if (isOCM) {
        this.state.currentPage = 0;
      }
      this.props.fetchPurchaseOrdersByFilter(
        this.context.router.routes[1].path,
        fromDate,
        toDate,
        days,
        this.state.Status,
        purchaser,
        productNum,
        shipFromDate,
        shipToDate,
        Type,
        undefined,
        this.state.productSearchType,
        undefined,
        undefined,
        this.state.limit,
        this.state.currentPage,
        this.getFilterParams(),
        isVAK,
      );
    });
  }

  refreshPOList = debounce((searchFilters) => {
    const status = this.state.Status;
    const { purchaseOrdersFilter } = this.props;
    if (!purchaseOrdersFilter) {
      let purchaser = this.props.Purchaser;
      if (this.props.Purchaser) {
        purchaser = this.props.Purchaser.value;
      }
      const fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
      const toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
      let { days } = this.state;
      if (days == null) {
        days = 7;
      }
      const shipFromDate = this.state.ShipFromDate ? this.formatDate(this.state.ShipFromDate) : '1900-01-01';
      const shipToDate = this.state.ShipToDate ? this.formatDate(this.state.ShipToDate) : '3000-01-01';
      const productNum = this.props.ProductNum;
      this.setState({ Status: status }, () => {
        if (isOCM) {
          this.state.currentPage = 0;
        }
        this.props.fetchPurchaseOrdersByFilter(
          this.context.router.routes[1].path,
          fromDate,
          toDate,
          days,
          this.state.Status,
          purchaser,
          productNum,
          shipFromDate,
          shipToDate,
          this.state.Type,
          undefined,
          this.state.productSearchType,
          undefined,
          undefined,
          this.state.limit,
          this.state.currentPage,
          this.getFilterParams(),
          isVAK,
          searchFilters
        );
      });
    } else {
      this.setState({ Status: status });
    }
  },500)

  fetchPurchaseOrdersByDetails(days) {
    if (this.state.filteredByItem) {
      this.setState({ days }, () => {
        this.fetchPurchaseOrdersByProduct(this.state.filterProductID);
      });
      return;
    }
    let FromDate = '1900-01-01';
    let ToDate = '3000-01-01';
    let ShipFromDate = '1900-01-01';
    let ShipToDate = '3000-01-01';
    let purchaser = this.props.Purchaser;
    const productNum = this.props.ProductNum;
    if (this.state.FromDate != null) {
      FromDate = this.formatDate(this.state.FromDate);
    }
    if (this.state.ToDate != null) {
      ToDate = this.formatDate(this.state.ToDate);
    }
    if (this.state.ShipFromDate != null) {
      ShipFromDate = this.formatDate(this.state.ShipFromDate);
    }
    if (this.state.ShipToDate != null) {
      ShipToDate = this.formatDate(this.state.ShipToDate);
    }

    if (this.props.Purchaser) {
      purchaser = this.props.Purchaser.value;
    }

    if (days === '-1' || days === -1) {
      this.setState({ days }, () => {
        if (isOCM) {
          this.state.currentPage = 0;
        }
        this.props.fetchPurchaseOrdersByFilter(
          this.context.router.routes[1].path,
          FromDate,
          ToDate,
          days,
          this.state.Status,
          purchaser,
          productNum,
          ShipFromDate,
          ShipToDate,
          this.state.Type,
          undefined,
          this.state.productSearchType,
          undefined,
          undefined,
          this.state.limit,
          this.state.currentPage,
          this.getFilterParams(),
          isVAK,
        );
      });
    } else {
      this.setState({ days, FromDate: undefined, ToDate: undefined, shipFromDate: undefined, shipToDate: undefined }, () => {
        if (isOCM) {
          this.state.currentPage = 0;
        }
        this.props.fetchPurchaseOrdersByFilter(
          this.context.router.routes[1].path,
          FromDate,
          ToDate,
          days,
          this.state.Status,
          purchaser,
          productNum,
          ShipFromDate,
          ShipToDate,
          this.state.Type,
          undefined,
          this.state.productSearchType,
          undefined,
          undefined,
          this.state.limit,
          this.state.currentPage,
          this.getFilterParams(),
          isVAK,
        );
      });
    }
    this.setState({ selectedRows: [], days });
  }

  fetchPurchaseOrdersByProduct = (productID) => {
    let dateRange = -1;
    let FromDate = '1900-01-01';
    let ToDate = '3000-01-01';
    let ShipFromDate = '1900-01-01';
    let ShipToDate = '3000-01-01';
    let purchaser = this.props.Purchaser;
    const productNum = isVAK ? undefined : productID;
    if (this.state.FromDate != null) {
      FromDate = this.formatDate(this.state.FromDate);
    }
    if (this.state.ToDate != null) {
      ToDate = this.formatDate(this.state.ToDate);
    }
    if (this.state.ShipFromDate != null) {
      ShipFromDate = this.formatDate(this.state.ShipFromDate);
    }
    if (this.state.ShipToDate != null) {
      ShipToDate = this.formatDate(this.state.ShipToDate);
    }

    if (this.state.days != null && typeof this.state.days !== 'undefined') {
      dateRange = this.state.days;
    }

    if (this.props.Purchaser) {
      purchaser = this.props.Purchaser.value;
    }
    this.setState({ filteredByItem: true, selectedRows: [{}], filterProductID: productID });
    if (isOCM) {
      this.state.currentPage = 0;
    }
    this.props.fetchPurchaseOrdersByFilter(
      this.context.router.routes[1].path,
      FromDate,
      ToDate,
      dateRange,
      this.state.Status,
      purchaser,
      productNum,
      ShipFromDate,
      ShipToDate,
      this.state.Type,
      isVAK ? productID : undefined,
      isVAK ? 'RefNum' : this.state.productSearchType,
      undefined,
      undefined,
      this.state.limit,
      this.state.currentPage,
      this.getFilterParams(),
      isVAK,
    );
  };

  // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
  getFilterParams = () => {
    let filterParams = ''
    if (isOCM || isAP) {
      const filterPaires = [];
      _.forOwn(this.state.filters, (value, key) => {
        if (!ROWS_FILTER_BY_API_KEYS.includes(key)) {
          return;
        }
        filterPaires.push([getKeysMap(key, isAP ? AP_PURCHASE_ORDER_FILTER_KEY_OBJ : PURCHASE_ORDER_FILTER_KEY_OBJ), value.filterTerm].join('='))
      });
      filterParams = filterPaires.join('&');
      const {sortColumn, sortDirection} = this.state.apiSortInfo;
      if (['ASC', 'DESC'].includes(sortDirection)) {
        const key = getKeysMap(sortColumn, PURCHASE_ORDER_SORT_KEY_OBJ);
        const sort = getSortVal(key,sortDirection === "DESC");
        filterParams += `&sort=${sort}`;
      }
    }
    return filterParams;
  }

  handleSumTotal = (rows, isNoAll = false) => {
    if(!(isGGI || isABBLE || isCCW) || !rows) {
      return
    }
    let canceledTotal = 0;
    let total = 0;
    let totalNetWeight = 0;
    let totalCancelledNetWeight = 0;
    let totalQty = 0;
    let totalCancelledQty = 0;
    let canceledOrders = [];
    if (rows && rows.length !== 0) {
      rows.map((row) => {
        totalNetWeight += row.FinalNetWeight;
        total += row.FinalPrice;
        totalQty += isCCW ? row.OrderQty : row.TotalQuantity;
        if(row.PurchaseStatus == 'Canceled') {
          totalCancelledNetWeight += row.FinalNetWeight
          canceledTotal += row.FinalPrice;
          totalCancelledQty += isCCW ? row.OrderQty : row.TotalQuantity;
          canceledOrders.push(row);
        }
      });
    }
    if(!isNoAll) {
      this.setState({
        rowsCount:  rows.length || 0,
      })
    }
    this.setState({
      canceledOrders: canceledOrders.length,
      total,
      canceledTotal,
      totalNetWeight,
      totalQty,
      totalCancelledQty,
      totalCancelledNetWeight, });
  }

  renderTable() {
    if (this.props.isLoading && !this.props.error && !(isOCM || isAP)) return <Spinner />;
    else if (this.props.error) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger">{JSON.stringify(this.props.error)}</div>
        </ContentWrapper>
      );
    }

    // Parameters of the react-data-grid

    let tableHeight = window.innerHeight < 930 ? 270 : 270;

    const getRows = () => Data.Selectors.getRows(this.state);

    // smilinghome want to show all data without scrolling
    if (isSH) {
      if (getRows().length > 0) {
        tableHeight = Math.min(getRows().length * 25 + 55)
      }
    }

    const getSize = () => getRows().length;
    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const onRowClick = (rowIdx, row) => {
      if (rowIdx !== -1) {
        const rows = getRows();
        rows.map((r) => {
          r.isSelected = false;
        });
        rows[rowIdx].isSelected = true;
        this.setState({ rows, selectedRows: [rows[rowIdx]], currencyCode: row.CurrencyCode});
        this.props.fetchPurchaseOrderList(row.PurchaseOrder_id);
      }
    };

    const onCellSelected = (coordinates) => {
      const rows = getRows();
      rows.map((r) => {
        r.isSelected = false;
      });
      rows[coordinates.rowIdx].isSelected = true;
      this.setState({ rows, selectedRows: [rows[coordinates.rowIdx]] });
    };

    const onClearFilters = () => {
      // all filters removed
      this.setState({ filters: {}, rows:this.state.rows }, () => {
        if (isOCM || isAP) {
          handleOnPageChange({
            selected: 0,
          })
        }
      });
    };

    // Handle the sortable function
    const handleGridSort = (sortColumn, sortDirection) => {
      if (isOCM || isAP) {
        this.setState({
          apiSortInfo: {sortColumn, sortDirection},
        }, () => {
          handleSortChangeGetData();
        })
      } else {
        const state = Object.assign({}, this.state, { sortColumn, sortDirection });
        this.setState(state);
      }
    };

    const defaultHandleFilterChange = (filter) => {
      const { rows } = this.state;
      if (rows && rows.length !== 0) {
        rows.map((row) => {
          if(isGGI) {
            row.isSelected = false;
            row.Dropship = row.is_transloading ? 'yes' : 'no';
          } else {
            row.Dropship = row.IsDropship ? 'yes' : 'no';
          }
        });
      }
      if(isGGI) {
        this.setState({ selectedRows:[], rows });
      } else {
        if (isVAK) {
          const searchFilters = Object.assign({}, this.state.searchFilters);
          if (filter.filterTerm) {
            searchFilters[filter.column.key] = filter;
          } else {
            delete searchFilters[filter.column.key];
          }
          this.setState({
            searchFilters
          })
          this.refreshPOList(searchFilters)
          return;
        } else {
          this.setState({ rows });
        }
      }
      const newFilters = Object.assign({}, this.state.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      this.setState({ filters: newFilters });
    }
    const ocmHandleFilterChange = debounce(
      (filter) => {
        const { rows } = this.state;
        if (rows && rows.length !== 0) {
          rows.map((row) => {
            if(isGGI) {
              row.Dropship = row.is_transloading ? 'yes' : 'no';
            } else {
              row.Dropship = row.IsDropship ? 'yes' : 'no';
            }
          });
        }
        this.setState({ rows });
        const newFilters = Object.assign({}, this.state.filters);
        if (filter.filterTerm) {
          newFilters[filter.column.key] = filter;
        } else {
          delete newFilters[filter.column.key];
        }
        this.setState({ filters: newFilters }, () => {
          if (!ROWS_FILTER_BY_API_KEYS.includes(filter.column.key)) {
            return
          }
          handleOnPageChange({
            selected: 0
          })
        });
      },
      500,
      { maxWait: 800 },
    );
    const handleFilterChange = (isOCM || isAP) ? ocmHandleFilterChange : defaultHandleFilterChange

    const onRowsSelected = (rows) => {
      const newRows = getRows();
      let selectedRows = [];
      rows.map(r => {
        newRows[r.rowIdx].isSelected = true;
      });

      newRows.map(r => {
        if (r.isSelected === true) {
          selectedRows.push(r);
        }
      });
      this.setState({ ...this.state, selectedRows, rows: newRows}, () => {
        this.mergePurchaseRows();
      })

    };
    const onRowsDeselected = (rows) => {
      const newRows = [...this.state.rows];
      const selectedRows = [...this.state.selectedRows];
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = false;
        const rowIndex = selectedRows.indexOf(r.row);
        selectedRows.splice(rowIndex, 1);
      });
      this.setState({ rows: newRows, selectedRows });
    };

    const handlePageChangeGetData = () => {
      let purchaser = this.props.Purchaser;
      if (this.props.Purchaser) {
        purchaser = this.props.Purchaser.value;
      }
      const fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
      const toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
      let { days } = this.state;
      if (days == null) {
        days = 7;
      }
      const shipFromDate = this.state.ShipFromDate ? this.formatDate(this.state.ShipFromDate) : '1900-01-01';
      const shipToDate = this.state.ShipToDate ? this.formatDate(this.state.ShipToDate) : '3000-01-01';

      const productNum = this.props.ProductNum;
      this.props.fetchPurchaseOrdersByFilter(
        this.context.router.routes[1].path,
        fromDate,
        toDate,
        days,
        this.state.Status,
        purchaser,
        productNum,
        shipFromDate,
        shipToDate,
        this.state.Type,
        undefined,
        this.state.productSearchType,
        undefined,
        undefined,
        this.state.limit,
        this.state.currentPage,
        this.getFilterParams(),
        isVAK,
      );
    }
    const handleSortChangeGetData = handlePageChangeGetData;
    const handleLimitChange = (el) => {
      this.state.currentPage = 0;
      this.state.limit = el.value;
      this.state.limitDisplay = el.label;
      this.setState({selectedRows: []});
      handlePageChangeGetData();
    }
    const handleOnPageChange = (data) => {
      this.state.currentPage = data.selected;
      handlePageChangeGetData();
    }

    const handleClickPodColumn = () => {
      setTimeout(() => {
        this.openManagePod();
      }, 300);
    }

    const handleRowUpdated = (e) => {
      const rows = getRows();
      if (isGFD && rows[e.rowIdx].PurchaseStatus!=='Received') {
        alert('Only received order can be edited');
      }
      if (isGFD && e.cellKey === 'score' && rows[e.rowIdx].PurchaseStatus==='Received') {
        axios({
          method: 'PUT',
          url: `${PURCHASE_ORDERS_URL}update/${rows[e.rowIdx].PurchaseOrder_id}`,
          data: {"score": e.updated.score},
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        })
        .then(res => {
          this.refreshList(true);
        })
        .catch(err => {
          alert(JSON.stringify(err.data));
        })
      }
    };


    const StatusFormatter = React.createClass({
      getStatus() {
        const {
          dependentValues,
          value,
        } = this.props;
        if (value === 'Placed' && dependentValues.container_num) {
          return 'In Transit';
        };
        return value;
      },
      render() {
        return (
          <span>{this.getStatus()}</span>
        )
      }
    })

    const limitSelection = isOLG ? [
      {
        label: '25',
        value: 25,
        name: 'limit',
      },
      {
        label: '50',
        value: 50,
        name: 'limit',
      },
      {
        label: '100',
        value: 100,
        name: 'limit',
      },
      {
        label: 'All',
        value: 99999,
        name: 'limit',
      },
    ] : isVAK ? [{
      label: '30',
      value: 30,
      name: 'limit',
    }, {
      label: 'All',
      value: 99999,
      name: 'limit',
    }] : (isSH || isAP) ? [{
      label: '10',
      value: 10,
      name: 'limit',
    }, {
      label: '20',
      value: 20,
      name: 'limit',
    }, {
      label: '50',
      value: 50,
      name: 'limit',
    }, {
      label: '100',
      value: 100,
      name: 'limit',
    }] : [{
      label: '30',
      value: 30,
      name: 'limit',
    }]

    let columns = [
      {
        key: 'PONum',
        name: <Translate value={(isSH || isAP) ? "sa_file_no" : "po_num"} />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      ...isVAK ? [{
        key: 'CommercialInvoice',
        name: <Translate value="commercial_invoice" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },{
        key: 'MfgNum',
        name: <Translate value="mfg_num" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }, {
        key: 'OutsourcingNum',
        name: <Translate value="outsourced_num" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }, {
        key: 'SubscriptionNum',
        name: <Translate value="pr_num" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }, {
        key: 'SubscriptionName',
        name: <Translate value="pr_creator" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }]:[],
      ...((isLAP || isAPD) || isVAK) ? [{
        key: 'VendorInvNO',
        name: <Translate value="vendor_invoice_no" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }]:[],
      ...(isABBLE || isSH || isAP) ? [] : [{
        key: 'VendorID',
        name: <Translate value="vendor_no" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }],
      ...(isSH || isAP) && [{
        key: 'shipnote',
        name: <Translate value="shipping_note" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }],
      {
        key: 'VendorName',
        name: <Translate value="vendor_name" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: (isSH || isAP) ? 90 : 200,
      },
      ...(isCCW && this.state.Type==='IsRelocation') && [{
        key: "TSONum",
        name: <Translate value="RSO_Num" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 120,
      }],
      ...(isEKC || isLMH || isBRO || isSDR || isCRW || isSC) ? [] : [{
        key: 'container_num',
        name: <Translate value="container_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      }],
      ...isGFD ? [{
        key: 'DropshipFrom',
        name: <Translate value="dropship_from" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      }] : [],
      ...isGFD ? [{
        key: 'DropshipTo',
        name: <Translate value="dropship_to" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      }] : [],
      ...(isCCW) && [{
        key: "OrderQty",
        name: <Translate value="total_order_qty" />,
        resizable: true,
        sortable: true,
        width: 96,
        filterable: true,
      }, {
        key: "ReceiveQTY",
        name: <Translate value="total_receive_qty" />,
        resizable: true,
        sortable: true,
        width: 116,
        filterable: true,
        getRowMetaData: row => row,
        formatter: (row) => (
          <div
            style={{ width: "100%", height: "100%" }}
            onDoubleClick={() => {
              if (row.value === 0 || row.value === null) {
                console.log('disable double click');
              } else {
                this.openEditReceiving(row.dependentValues.PONum, row.dependentValues.PurchaseOrder_id);
              }
            }}
          >
            {row.value}
          </div>
        ),
      }, {
        key: "ReceiveWT",
        name: <Translate value="total_receive_wt" />,
        resizable: true,
        sortable: true,
        width: 116,
        filterable: true,
      }],
      ...(isSH || isAP) && [{
        key: "TotalBoxes",
        name: <Translate value="total_box" />,
        resizable: true,
        sortable: true,
        width: 70,
        filterable: isAP ? false : true,
      }, {
        key: 'total_pc',
        name: <Translate value="pcs" />,
        resizable: true,
        sortable: true,
        width: 70,
        filterable: isAP ? false : true,
      }, {
        key: 'PurchaseStatus',
        name: <Translate value={"status"} />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      }, {
        key: 'Boln',
        name: <Translate value="bol" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }, {
        key: 'Vessel',
        name: <Translate value="vessel_no" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }],
      ...(isLMH || isBRO || isSDR || isCRW || isGFD || isSC) ? [{
        key: 'TSONum',
        name: <Translate value="dropship" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      }] : [],
      ...isGGI ? [{
        key: 'cso_num',
        name: <Translate value="cso_num" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      }]:[],
       ...((isLAP || isAPD) || isVAK || isGFD) ? [{
        key: isGFD ? 'HasPod' : 'hasPOD',
        name: <Translate value="has_pod" />,
        resizable: true,
        sortable: true,
        width: 80,
        // filterable: true,
        formatter: ({ value }) => (
          <div onClick={() => handleClickPodColumn()} style={{cursor: "pointer", width: "100%", display: 'flex', justifyContent: 'center', color: value ? 'green' : 'red', fontSize: 'large'}}>
            { value ? <em className="fa fa-check"></em> : <em className="fa fa-times"></em> }
          </div>
        ),
      }] : [],
      ...(isEKC || isLMH || isBRO || isSDR || isCRW || isSC || isABBLE || isGGI || isGFD || isAP) ? [] : [{
        key: 'fob_point',
        name: <Translate value="fob_point" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      }],
      ...(isGFD) && [{
        key: 'score',
        name: <Translate value="score" />,
        resizable: true,
        sortable: true,
        filterable: true,
        editable: true,
        width: 80,
      }],
      ...isABBLE ? [{
        key: 'Loading_Port',
        name: <Translate value="loading_port" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }] : [],
      ...isDAICHEONG ? [{
        key: 'TotalQuantity',
        name: <Translate value="total_qty" />,
        resizable: true,
        sortable: true,
        width: 60,
        filterable: true,
      }] : [],
      {
        key: 'FinalPrice',
        name: <Translate value={(isLAP || isAPD) ? "final_dollarsign2" : "final_dollarsign"} />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: isAP ? false : true,
        formatter: CashFormatter,
      },
      ...((isLAP || isAPD) || isCCW) && [{
        key: 'ReceiveFinalPrice',
        name: <Translate value={((isLAP || isAPD)) ? "final_dollarsign3" : "receive_dollarsign"} />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
        formatter: CashFormatter,
      }],
      {
        key: 'OrderDate',
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: isAP ? false : true,
        formatter: DateFormatter,
      },
      ...isABBLE ? [
        {
          key: 'start_date',
          name: <Translate value="shipping_start" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          formatter: DateFormatter,
        },{
          key: 'end_date',
          name: <Translate value="shipping_end" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          formatter: DateFormatter,
        }, {
          key: 'ETD_date',
          name: <Translate value="etd_date" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          formatter: DateFormatter,
        }
      ] : [],
      {
        key: 'ETADate',
        name: <Translate value="eta_date" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: isAP ? false : true,
        formatter: DateFormatter,
      },
      ...isABBLE ? [{
        key: 'ReceivedDate',
        name: <Translate value="receive_date" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
        formatter: DateFormatter,
      }] : [],
      ...isSV ? [{
        key: 'onboard_date',
        name: <Translate value="onboard_date" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
        formatter: DateFormatter,
      },
      {
        key: 'cancel_date',
        name: <Translate value="cancel_date" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
        formatter: DateFormatter,
      }] : [],
      ...isABBLE ? [{
        key: 'total_cbm',
        name: <Translate value="cbm" />,
        resizable: true,
        sortable: true,
        width: 70,
        filterable: true,
      },{
        key: 'total_CTN',
        name: <Translate value="ctn" />,
        resizable: true,
        sortable: true,
        width: 70,
        filterable: true,
      },{
        key: 'total_PCS',
        name: <Translate value="pcs" />,
        resizable: true,
        sortable: true,
        width: 70,
        filterable: true,
      }] : [],
      {
        key: 'ShipTo',
        name: <Translate value="shipto" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: isAP ? false : true,
      },
      ...isVAK ? [
        {
          key: 'Review_Status',
          name: <Translate value="review_status" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          formatter: ({ value }) => (
            <div>
              {value === 'Reject' ? <Translate value="reject_review" /> :
              value === 'Confirm' ? <Translate value="confirm_review" /> :
              value === 'Pending' ? <Translate value="po_pending" /> : value}
            </div>
          ),
        },
        {
          key: 'Approve_Status',
          name: <Translate value="approve_status" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          formatter: ({ value }) => (
            <div>
              {value === 'Reject' ? <Translate value="reject_review" /> :
              value === 'Confirm' ? <Translate value="confirm_review" /> :
              value === 'Pending' ? <Translate value="pending" /> : value}
            </div>
          ),
        }
      ]:[],
      ...isUSPride && [{
        key: 'PurchaseStatus',
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: StatusFormatter,
        getRowMetaData: row => row,
      }],
      ...!(isUSPride || isSH || isAP) && [{
        key: 'PurchaseStatus',
        name: <Translate value={isVAK ? "po_or_status" : "status"} />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: ({ value }) => (
          <div>
            {isVAK ? value === 'Placed' ? <Translate value="receive_placed" /> : <Translate value={value} /> : value}
          </div>
        ),
      }],
      ...(isLMH || isBRO) && [{
        key: 'IsMES',
        name: <Translate value="is_mes" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: ({ value }) => (
          <div>
            {value ? <Translate value="yes" /> : <Translate value="no" />}
          </div>
        ),
      }],
      ...((isEKC || isLMH || isBRO || isSDR || isCRW || isSC) && (this.context.router.routes[1].path === "dropshipOrder")) ? [{
        key: 'DropshipStatus',
        name: <Translate value="dropship_status" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 110,
        getRowMetaData: row => row,
        formatter: ({ value }) => (
          <div
            style={{ width: "100%", height: "100%", textAlign: "center" }}
          >
            {(value === 'Open') ? 'Pending' : value}
          </div>
        ),
      }] : [],
      ...isABBLE ? [] : [{
        key: 'ReceivedDate',
        name: <Translate value="receive_date" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: isAP ? false : true,
        formatter: DateFormatter,
      }],
      ...(isEKC || isLMH || isBRO || isSDR || isCRW || isSC || isSH || isAP) ? [] : [{
        key: 'Dropship',
        name: <Translate value="ds" />,
        resizable: true,
        sortable: true,
        width: 40,
        filterable: true,
      }],
      ...(isEKC || isLMH || isBRO || isSDR || isCRW || isSC) ? [] : [{
        key: 'Purchaser_User_Name',
        name: <Translate value="purchaser" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }],
      ...(isEKC || isLMH || isBRO || isSDR || isCRW || isSC || isSH || isAP) ? [] : [{
        key: 'ShippingCost',
        name: <Translate value="ship_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 65,
        filterable: true,
        formatter: CashFormatter,
      }],
      ...(isEKC || isLMH || isBRO || isSDR || isCRW || isSH || isAP) ? [] : [ {
        key: 'MiscCost',
        name: <Translate value="misc_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 65,
        filterable: true,
        formatter: CashFormatter,
      }],
      ...isABBLE ? [{
        key: 'VendorID',
        name: <Translate value="vendor_no" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }] : [],
      ...isVAK ? [{
        key: 'note',
        name: <Translate value="note" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }] : [],
    ];


    if(isSH || isAP) {
      columns.push({
        key: 'MeasurementInCBM',
        name: <Translate value="measurement_in_cbm" />,
        resizable: true,
        sortable: true,
        width: 130,
        filterable: isAP ? false : true,
      }, {
        key: 'GrossWeight',
        name: <Translate value="gross_weight" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: isAP ? false : true,
      })
    }

    if (isGGI) {
      const purchaserIndex = _.findIndex(columns, { key: 'Purchaser_User_Name' });
      const dropShipIndex = _.findIndex(columns, { key: 'Dropship' });
      const creator = {
        key: 'Purchaser_User_Name',
        name: <Translate value="creator" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }
      const newPuchaser = {
        key: 'Purchaser_name',
        name: <Translate value="purchaser" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }
      const tsoNum = {
        key: 'TSONum',
        name: <Translate value="TSO" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }
      columns.splice(purchaserIndex, 1, creator, newPuchaser);
      columns.splice(dropShipIndex + 1, 0, tsoNum);
    }
    if (isTN) {
      columns = [
        {
          key: 'PONum',
          name: <Translate value="po_num" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },

        {
          key: "container_num",
          name: <Translate value="container_no" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'VendorID',
          name: <Translate value="vendor_no" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'VendorName',
          name: <Translate value="vendor_name" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 200,
        },
        {
          key: "customer_name",
          name: "Client.Cust",
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'OrderDate',
          name: <Translate value="ordered" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          formatter: DateFormatter,
        },
        {
          key: 'ETADate',
          name: <Translate value="eta_date" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          formatter: DateFormatter,
        },
        {
          key: "order_type",
          name: <Translate value="po_type" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: "refnum1",
          name: <Translate value="ref#1" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          },
        {
          key: "refnum2",
          name: <Translate value="ref#2" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'ShipTo',
          name: <Translate value="shipto" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'PurchaseStatus',
          name: <Translate value="status" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'ReceivedDate',
          name: <Translate value="receive_date" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          formatter: DateFormatter,
        },
        {
          key: 'Dropship',
          name: <Translate value="ds" />,
          resizable: true,
          sortable: true,
          width: 40,
          filterable: true,
        },
        {
          key: 'Purchaser_User_Name',
          name: <Translate value="purchaser" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
      ];
    }

    if (isGFD) {
      const temp1 = {
          key: 'merged_from',
          name: <Translate value="merged_from" />,
          resizable: true,
          sortable: true,
          width: 165,
          filterable: true,
        };
        const temp2 = {
          key: 'ParentPONum',
          name: <Translate value="parent_po" />,
          resizable: true,
          sortable: true,
          width: 165,
          filterable: true,
        };
      columns.push(temp1)
      columns.push(temp2)
    }

    if (true) {
      columns.push({
        key: 'create_user_name',
        name: <Translate value="created_by" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: isAP ? false : true,
      }, {
        key: 'modify_user_name',
        name: <Translate value="modified_by" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: isAP ? false : true,
      },
      ...isGFD && [{
        key: 'fob_point',
        name: <Translate value="fob_point" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      }],
      ...(isSH || isAP) && [{
        key: 'CreateTime',
        name: <Translate value="created_date" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: isAP ? false : true,
        formatter: DateFormatter,
      }, {
        key: 'modify_datetime',
        name: <Translate value="modified_date" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: isAP ? false : true,
        formatter: DateFormatter,
      }])
    }

    const showPagination = isOCM || isVAK || isOLG || isSH || isAP
    const totalPages = this.props.totalPages
    // React Table Purchase Order Full Table
    return (
      <div>
        <Row>
          <Col xs={12}>
            <div id="PurchaseOrderList-dataGrid1" style={{marginTop: (isVAK || isOLG) ? '40px' : ((isSV || isSH) ? '0px' : '30px')}}>
              <ReactDataGrid
                rowKey="PurchaseOrder_id"
                enableCellSelect
                onClearFilters={onClearFilters}
                onGridSort={handleGridSort}
                toolbar={<Toolbar enableFilter />}
                onAddFilter={handleFilterChange}
                columns={columns}
                rowHeight={25}
                headerRowHeight={45}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                minHeight={tableHeight}
                enableRowSelect="multi"
                onRowUpdated={this.handleRowUpdated}
                rowSelection={{
                  showCheckbox: true,
                  onRowsSelected,
                  onRowsDeselected,
                  selectBy: {
                    isSelectedKey: 'isSelected',
                  },
                }}
                onRowClick={onRowClick}
                onCellSelected={onCellSelected}
              />
            </div>
          </Col>
        </Row>
        {
          showPagination && <Row>
            <Col xs={6} style={{display: 'flex'}}>
              <div style={{ width: '600px' }} id="react-pagination">
                <ReactPaginate
                  previousLabel={<Translate value="prev_page" />}
                  nextLabel={<Translate value="next_page" />}
                  containerClassName={'pagination'}
                  activeClassName={'active'}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  pageCount={totalPages}
                  onPageChange={handleOnPageChange}
                  forcePage={this.state.currentPage}
                />
              </div>
              <div  style={{ width: '100px', marginTop: '6px', marginLeft: '15px'}}>
                <Dropdown>
                  <Dropdown.Toggle style={{ height: '28px', width: '60px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' }}>
                    {this.state.limitDisplay}
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="super-colors">
                    {limitSelection.map(el => {
                      return (
                        <MenuItem onClick={() => handleLimitChange(el)}>{el.label}</MenuItem>
                      )
                    })}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </Col>
          </Row>
        }
        {this.renderTotal()}
      </div>
    );
  }

  renderPodDelete = () => {
    const { podImageRows } = this.state;
    let id = null;
    if (podImageRows && podImageRows.selectedRows && podImageRows.selectedRows.length === 1) {
      id = isGFD ? podImageRows.selectedRows[0].id : podImageRows.selectedRows[0].Image_id;
    }
    const onhandleDelete = (e) => {
      let url = isGFD ? `${ROOT_URL}v2/upload_purchase_order_file/${id}` : `${ROOT_URL}v2/upload_images/${id}?type=PO_POD`
      axios({
        method: 'DELETE',
        url,
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      })
        .then((res) => {
          if (res.error) {
            alert(JSON.stringify(res.error));
          } else {
            if(res.status === 200){
              this.refreshList()
            }
            this.fetchPod();
          }
        });
    }
    return (
      <div>
        <Button
          style={{ marginLeft: '5px' }}
          bsStyle="danger"
          type="button"
          onClick={() => { onhandleDelete() }}
          disabled={!id}
        >
          <em className="fa fa-trash" /><Translate value="delete" />
        </Button>
      </div>
    )
  }

  renderPodUpload = () => {
    const { selectedRows } = this.state;

    const onInputClick = (event) => {
      event.target.value = ''
    }
    const handleChange = (e) => {
      const formData = new FormData();
      for (const key of Object.keys(e.target.files)) {
        formData.append('images', e.target.files[key]);
      }
      let url = isGFD ? `${ROOT_URL}v2/upload_purchase_order_file/${selectedRows[0].PurchaseOrder_id}?type=1` : `${ROOT_URL}v2/upload_images/${selectedRows[0].PurchaseOrder_id}?type=PO_POD`
      axios({
        method: 'POST',
        data: formData,
        url,
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      })
        .then((res) => {
          if (res.error) {
            alert(JSON.stringify(res.error));
          } else {
            if(res.status === 200){
              this.refreshList()
            }
            this.fetchPod();
          }
        });

    }
    return (
      <div>
        <input id="lap_pod_ref" ref='lap_pod_ref' type="file" style={{ visibility: 'hidden', width: '0px', height: '0px' }} onClick={onInputClick} onChange={(e) => { handleChange(e) }} multiple />
        <Button
          style={{ marginLeft: '5px' }}
          bsStyle="success"
          type="button"
          onClick={() => { this.refs.lap_pod_ref.click(); }}
          disabled={false}
        >
          <em className="fa fa-plus" /><Translate value="create" />
        </Button>
      </div>
    )
  }

  handleVendorInvoiceNoChange = (num, imageId) => {
    const formData = new FormData();
    formData.append('invoice_num', num)
    let url = isGFD ? `${ROOT_URL}v2/upload_purchase_order_file/${imageId}?type=1` : `${ROOT_URL}v2/upload_images/${imageId}?type=PO_POD`
    axios({
      method: 'PUT',
      data: formData,
      url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
      .then((res) => {
        if (res.error) {
          alert(JSON.stringify(res.error));
        } else {
          // this.fetchPod();
        }
      });

  }

  renderPodTable() {
    // Parameters of the react-data-grid
    // const tableHeight = window.innerHeight < 930 ? 185 : 185;
    const tableHeight = (isLAP || isAPD) ? 240 : 470;

    const getRows = () => Data.Selectors.getRows(this.state.podImageRows);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const onRowsSelected = (rows) => {
      const newRows = getRows();
      newRows.map((r) => {
        r.isSelected = false;
      });
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = true;
      });
      const podImageRows = {
        ...this.state.podImageRows,
        rows: newRows,
        selectedRows: [rows[0].row],
      };
      this.setState({ podImageRows });
    };

    const onRowsDeselected = (rows) => {
      const newRows = getRows();
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = false;
      });
      const podImageRows = {
        ...this.state.podImageRows,
        rows: newRows,
        selectedRows: [],
      };
      this.setState({ podImageRows });
    };

    const handleRowUpdated = (e) => {
      // merge updated row with current row and rerender by setting state
      const rows = getRows();
      if (isVAK && e.updated.invoice_num != null) {
        Object.assign(rows[e.rowIdx], { invoice_num: e.updated.invoice_num });
        this.handleVendorInvoiceNoChange(e.updated.invoice_num, rows[e.rowIdx].Image_id)
      }
      Object.assign(rows[e.rowIdx], e.updated);
      const podImageRows = {
        ...this.state.podImageRows,
        rows,
      };
      this.setState({ podImageRows });
    };

    let columns =
      [
        {
          key: 'ImageURL2',
          name: !(isVAK || isGFD) ? <Translate value="pod" /> : <Translate value="operation" />,
          resizable: true,
          sortable: true,
          width: (isLAP || isAPD) ? 210 : 110,
          filterable: true,
          // getRowMetaData: row => row,
          formatter: ({ value }) => {
            if (!value) return <span />
            return <a href={value} style={{width: '100%', display: 'flex', justifyContent: 'center'}}>Download</a>;
          }
        },
        ...isVAK ? [{
          key: "ImageURL",
          name: <Translate value="file_name" />,
          resizeable: true,
          width: 300,
          sortable: false,
          editable: false,
          filterable: false,
          formatter: (row) => {
            return(
            <div style={{width: '100%', textAlign:'center',wordBreak: 'break-all',textWrap: 'wrap'}}>
              {row.dependentValues.file_name}
            </div>
          )},
          getRowMetaData: (row) => row,
        }, {
          key: "invoice_num",
          name: <Translate value="vendor_invoice_no" />,
          resizeable: true,
          width: 200,
          sortable: false,
          editable: true,
          filterable: false
        }]: (isLAP || isAPD) ? []:
        [
          {
            key: "ImageURL",
            name: <Translate value={isGFD ? "file_name" : "image"} />,
            resizeable: true,
            width: 300,
            sortable: false,
            editable: false,
            filterable: false,
            formatter: ({ dependentValues, value }) => {
              let imgFlag = dependentValues.ImageURL.endsWith('jpg') || dependentValues.ImageURL.endsWith('jpeg') || dependentValues.ImageURL.endsWith('png') || dependentValues.ImageURL.endsWith('gif')
              return isGFD ?
              <div style={{width: '100%', textAlign:'center',wordBreak: 'break-all',textWrap: 'wrap'}}>
              {imgFlag ?
                <div>
                  <img
                    style={{ width: "150px", height: "70px", objectFit: 'contain', }}
                    src={dependentValues.ImageURL}
                  />
                  <div>{dependentValues.file_name}</div>
                </div> :
                <div>
                  <em className="fa fa-file-text" style={{fontSize: "55px"}}/>
                  <div>{dependentValues.file_name}</div>
                </div>
              }
            </div>
            : (
              <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                <img style={{ height: '100px', objectFit: 'contain' }} src={value} />
              </div>
            )},
            getRowMetaData: (row) => row,
          },
        ],
      ];

    // React Table Purchase Order Details
    return (
      <Row>
        <Col xs={12}>
          <div className="recat-customizer" id="PurchaseOrderList-dataGrid2">
            <ReactDataGrid
              enableCellSelect
              headerRowHeight={45}
              // onGridSort={handleGridSort}
              // onAddFilter={handleFilterChange}
              // onClearFilters={onClearFilters}
              columns={columns}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              rowHeight={(isLAP || isAPD) ? 60 : 100}
              minHeight={tableHeight}
              enableRowSelect="single"
              rowSelection={{
                showCheckbox: true,
                onRowsSelected,
                onRowsDeselected,
                selectBy: {
                  isSelectedKey: 'isSelected',
                },
              }}
              onRowUpdated={handleRowUpdated}
            />
          </div>
        </Col>
      </Row>
    );
  }

  renderProductsTable() {
    if (this.props.purchaseOrderListIsLoading && !this.props.purchaseOrderListError) return <Spinner />;
    else if (this.props.purchaseOrderListError) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger">{JSON.stringify(this.props.purchaseOrderListError)}</div>
        </ContentWrapper>
      );
    }

    // Parameters of the react-data-grid
    let tableHeight = window.innerHeight < 930 ? 185 : 185;

    const getRows = () => Data.Selectors.getRows(this.state.purchaseOrderDetail);

    // smilinghome want to show all data without scrolling
    if (isSH || isAP) {
      if (getRows().length > 0) {
        tableHeight = Math.min(getRows().length * 25 + 55)
      }
    }

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    // Handle the sortable function
    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state.purchaseOrderDetail, { sortColumn, sortDirection });
      this.setState({ purchaseOrderDetail: state });
    };

    const onClearFilters = () => {
      // all filters removed
      const purchaseOrderDetail = { ...this.state.purchaseOrderDetail, filters: {} };
      this.setState({ purchaseOrderDetail });
    };

    const handleFilterChange = (filter) => {
      const newFilters = Object.assign({}, this.state.purchaseOrderDetail.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      const purchaseOrderDetail = { ...this.state.purchaseOrderDetail, filters: newFilters };
      this.setState({ purchaseOrderDetail });
    };

    const onRowSelect = (rows) => {
      const purchaseOrderDetail = { ...this.state.purchaseOrderDetail, selectedRows: rows };
      this.setState({ purchaseOrderDetail });
    };

    // Column definition
    let columns = (!this.state.currencyCode || this.state.currencyCode === 'USD')
    ?
    [
      ...(isEKC || isLMH || isBRO || isSDR || isCRW || isSC || isOLG || isSH || isAP) ? [] : [{
        key: 'ProductNum',
        name: <Translate value="product_num" />,
        resizable: true,
        sortable: true,
        width: 100,
      }],
      ...(isEKC || isLMH || isBRO) ? [] : [{
        key: 'RefNum',
        name: <Translate value={isOLG ? "item_no" : isVAK ? "sku" : "ref_num"} />,
        resizable: true,
        sortable: true,
        width: 100,
      }],
      ...(isEKC || isLMH || isBRO || isSDR || isCRW || isSC || isGGI || isSH || isAP) ? [] : [{
        key: 'VendorProductNum',
        name: <Translate value="vendor_product_number" />,
        resizable: true,
        sortable: true,
        width: 150,
      }],
      {
        key: 'Name',
        name: <Translate value="product_name" />,
        resizable: true,
        sortable: true,
        width: 250,
      },
      ...(isLMH || isBRO) && [{
        key: 'RefNum',
        name: <Translate value="ref_num" />,
        resizable: true,
        sortable: true,
        width: 130,
      }],
      ...((isLAP || isAPD) || isSH || isAP) ? [] : [{
        key: 'Description',
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        width: 200,
      }],
      ...(isSH || isAP) && [{
        key: 'prepare_purchase_order_num',
        name: <Translate value="po_no" />,
        resizable: true,
        sortable: true,
        width: 100,
      }],
      ...(isSV) ? [{
        key: 'Barcode',
        name: <Translate value="barcode" />,
        resizable: true,
        sortable: true,
        width: 150,
      }] : [],
      ...(isABBLE || isEKC || isLMH || isBRO || isSDR || isCRW || isSC || isSH || isAP) ? [] : [{
        key: 'expire_date',
        name: <Translate value="expire_date" />,
        resizable: true,
        sortable: true,
        width: 80,
      }],
      ...(isEKC || isLMH || isBRO || isSDR || isCRW || isSC || isGFD) ? [] : [{
        key: 'PackageType',
        name: <Translate value="pkg_type" />,
        resizable: true,
        width: 50,
        sortable: true,
      }],
        ...(isGFD) ? [{
          key: 'purchase_convert_unit',
          name: <Translate value="convert_num" />,
          resizable: true,
          width: 70,
          sortable: true,
        }] : [],
      ...isAP ? [{
          key: 'pkgunit1',
          name: <Translate value="packageSize" />,
          resizable: true,
          width: 90,
          sortable: true,
          getRowMetaData: row => row,
          formatter: ({ dependentValues, value }) => {
            let pkgsize = `${dependentValues.pkgsize1}${dependentValues.pkgunit1}*${dependentValues.pkgsize2}${dependentValues.pkgunit2}`
            return (
              <div>{pkgsize}</div>
            )
          }
      },] : [],
      {
        key: 'OrderQuantity',
        name: isABBLE ? <Translate value="ctn" /> : (isSH || isAP) ? <Translate value="shipped_qty" /> : isGFD ? <Translate value="case_qty" /> : <Translate value="order_qty" />,
        resizable: true,
        width: 90,
        sortable: true,
        getRowMetaData: row => row,
        formatter: ({ dependentValues, value }) => {
          if (isGFD && dependentValues.highlighted === true ) {
            return (
            <div style={{ backgroundColor: 'yellow'}}>{value}</div>
            )
          } else {
            return (
            <div>{value}</div>
            )
          }
        }
      },
      ...(isGFD) ? [{
        key: 'unit_quantity',
        name: <Translate value="unit_qty" />,
        resizable: true,
        width: 90,
        sortable: true,
      }] : [],
      ...(isSH || isAP) && [{
        key: 'ReceiveQuantity',
        name: <Translate value="receive_qty" />,
        resizable: true,
        width: 70,
        sortable: true,
      }],
      ...isABBLE ? [{
        key: 'purchase_convert_unit',
        name: <Translate value="convert_quantity" />,
        resizable: true,
        width: 90,
        sortable: true,
      },{
        key: 'psc_quantity',
        name: <Translate value="pcs" />,
        resizable: true,
        width: 70,
        sortable: true,
      }] : [],
      ...(isEKC || isLMH || isBRO || isCRW || isSDR || isSC || isSH || isAP || isGFD) ? [] : [{
        key: 'OrderTotalNetWeight',
        name: <Translate value="order_wt" />,
        resizable: true,
        width: 70,
        sortable: true,
      }],
      ...(isGFD) && [{
        key: 'OrderTotalNetWeight',
        name: <Translate value="total_wt" />,
        resizable: true,
        width: 70,
        sortable: true,
      }],
      ...isCCW ? [{
        key: 'ReceiveQuantity',
        name: <Translate value="receive_qty" />,
        resizable: true,
        width: 70,
        sortable: true,
      }, {
        key: 'ReceiveTotalWeight',
        name: <Translate value="receive_wt" />,
        resizable: true,
        width: 70,
        sortable: true,
      }] : [],
      ...isABBLE ? [{
        key: 'shipping_weight',
        name: <Translate value="total_ship_wt" />,
        resizable: true,
        width: 110,
        sortable: true
      }] : [],
      ...isGGI ? [{
        key: 'small_unit_price',
        name: <Translate value="order_small_unit_dollarsign" />,
        resizable: true,
        width: 110,
        sortable: true,
        formatter: CashFormatter,
      }] : [],
      {
        key: 'OrderUnitPrice',
        name: isGFD ? <Translate value="cost_dollarsign" /> : <Translate value="order_unit_dollarsign" />,
        resizable: true,
        width: 110,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: 'OrderTotalPrice',
        name: <Translate value="order_total_dollarsign" />,
        resizable: true,
        width: 110,
        sortable: true,
        formatter: CashFormatter,
      },
      ...(isEKC || isLMH || isBRO || isSDR || isCRW || isSC || isABBLE || isSH || isAP) ? [] : [{
        key: isPS ? 'dimension' : 'dimension_shipping',
        name: isPS ? 'DIM (in)' : <Translate value="package_dimension_shipping" />,
        resizable: true,
        width: 95,
        sortable: true,
      }],
      ...isABBLE && [{
        key: 'cbm',
        name: <Translate value="CBM" />,
        resizable: true,
        width: 70,
        sortable: true,
      }],
      ...(isEKC || isLMH || isBRO || isSDR || isCRW || isSC || isSH || isAP) ? [] : [{
        key: 'weight_shipping',
        name: <Translate value="package_weight_shipping" />,
        resizable: true,
        width: 95,
        sortable: true,
      }],
      ...(isEKC || isLMH || isBRO || isSDR || isCRW || isSC || isSH || isAP || isCCW) ? [] : [{
        key: 'ReceiveQuantity',
        name: <Translate value="receive_qty" />,
        resizable: true,
        width: 70,
        sortable: true,
      }],
      ...(isEKC || isLMH || isBRO || isSDR || isCRW || isSC || isSH || isAP || isCCW) ? [] : [{
        key: 'ReceiveTotalWeight',
        name: <Translate value="receive_wt" />,
        resizable: true,
        width: 70,
        sortable: true,
      }],
      ...(isEKC || isLMH || isBRO || isSDR || isCRW || isSC) ? [] : [{
        key: 'ReceiveUnitPrice',
        name: <Translate value="receive_unit_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      }],
      ...(isEKC || isLMH || isBRO || isSDR || isCRW || isSC) ? [] : [{
        key: 'ReceiveTotalPrice',
        name: <Translate value="receive_total_dollarsign" />,
        resizable: true,
        width: 80,
        sortable: true,
        formatter: CashFormatter,
      }],
      ...(isLAP || isAPD) ? [{
        key: 'Description',
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        width: 200,
      }] : [],
      ...isAP ? [{
        key: 'color',
        name: <Translate value="color" />,
        resizable: true,
        width: 80,
      },
      {
        key: 'size_ratio',
        name: <Translate value="size_ratio" />,
        resizable: true,
        width: 160,
      }] : [],
    ]
    :
    [
      {
        key: 'ProductNum',
        name: <Translate value="product_num" />,
        resizable: true,
        sortable: true,
        width: 100,
      },
      {
        key: 'RefNum',
        name: <Translate value={isOLG ? "item_no" : "ref_num"} />,
        resizable: true,
        sortable: true,
        width: 70,
      },
      {
        key: 'Name',
        name: <Translate value="product_name" />,
        resizable: true,
        sortable: true,
        width: 250,
      },
      ...(isLAP || isAPD) ? [] : [{
        key: 'Description',
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        width: 200,
      }],
      {
        key: 'expire_date',
        name: <Translate value="expire_date" />,
        resizable: true,
        sortable: true,
        width: 80,
      },
      {
        key: 'PackageType',
        name: <Translate value="pkg_type" />,
        resizable: true,
        width: 50,
        sortable: true,
      },
      {
        key: 'OrderQuantity',
        name: <Translate value="order_qty" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
      {
        key: 'OrderTotalNetWeight',
        name: <Translate value="order_wt" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
      {
        key: 'OrderUnitPrice',
        name: isVAK ? <Translate value="order_unit_dollarsign" /> : <span><Translate value="order_unit" /> ({this.state.currencyCode})</span>,
        resizable: true,
        width: 100,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: 'currency_unit',
        name: isVAK ? <span><Translate value="order_unit" /> ({this.state.currencyCode})</span> : <Translate value="order_unit_dollarsign"/>,
        resizable: true,
        width: 100,
        sortable: true,
      },
      {
        key: 'OrderTotalPrice',
        name: isVAK ? <Translate value="order_total_dollarsign" /> : <span><Translate value="order_total" /> ({this.state.currencyCode})</span>,
        resizable: true,
        width: 100,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: 'currency_subtotal',
        name: isVAK ? <span><Translate value="order_total"/> ({this.state.currencyCode})</span> : <Translate value="order_total_dollarsign"/>,
        resizable: true,
        width: 100,
        sortable: true,
      },
      ...isABBLE ? [{
        key: 'cbm',
        name: <Translate value="CBM" />,
        resizable: true,
        width: 70,
        sortable: true,
      }] : [{
          key: isPS ? 'dimension' : 'dimension_shipping',
          name: isPS ? 'DIM (in)' : <Translate value="package_dimension_shipping" />,
          resizable: true,
          width: 95,
          sortable: true,
      }],
      {
        key: 'weight_shipping',
        name: <Translate value="package_weight_shipping" />,
        resizable: true,
        width: 95,
        sortable: true,
      },
      {
        key: 'ReceiveQuantity',
        name: <Translate value="receive_qty" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
      {
        key: 'ReceiveTotalWeight',
        name: <Translate value="receive_wt" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
      {
        key: 'ReceiveUnitPrice',
        name: <Translate value="receive_unit_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: 'ReceiveTotalPrice',
        name: <Translate value="receive_total_dollarsign" />,
        resizable: true,
        width: 80,
        sortable: true,
        formatter: CashFormatter,
      },
      ...(isLAP || isAPD) ? [{
        key: 'Description',
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        width: 200,
      }] : [],
      ...isAP ? [{
        key: 'color',
        name: <Translate value="color" />,
        resizable: true,
        width: 80,
      },
      {
        key: 'size_ratio',
        name: <Translate value="size_ratio" />,
        resizable: true,
        width: 160,
      }] : [],
    ]

    if (isTN) {
      columns = (!this.state.currencyCode || this.state.currencyCode === 'USD')
      ?
      [
        {
          key: 'ProductNum',
          name: <Translate value="product_num" />,
          resizable: true,
          sortable: true,
          width: 100,
        },
        {
          key: 'RefNum',
          name: <Translate value="sku" />,
          resizable: true,
          sortable: true,
          width: 70,
        },
        {
          key: 'VendorProductNum',
          name: <Translate value="vendor_product_number" />,
          resizable: true,
          sortable: true,
          width: 150,
        },
        {
          key: 'Name',
          name: <Translate value="product_name" />,
          resizable: true,
          sortable: true,
          width: 250,
        },
        {
          key: 'Description',
          name: <Translate value="description" />,
          resizable: true,
          sortable: true,
          width: 200,
        },
        {
          key: 'expire_date',
          name: <Translate value="expire_date" />,
          resizable: true,
          sortable: true,
          width: 80,
        },
        {
          key: 'PackageType',
          name: <Translate value="pkg_type" />,
          resizable: true,
          width: 50,
          sortable: true,
        },
        {
          key: 'OrderQuantity',
          name: <Translate value="order_qty" />,
          resizable: true,
          width: 70,
          sortable: true,
        },
        {
          key: "total_box",
          name: <Translate value="total_box" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: "pc_box",
          name: <Translate value="pc_box" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: "pack",
          name: <Translate value="pack" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'OrderTotalNetWeight',
          name: <Translate value="order_wt" />,
          resizable: true,
          width: 70,
          sortable: true,
        },
        {
          key: isPS ? 'dimension' : 'dimension_shipping',
          name: isPS ? 'DIM (in)' : <Translate value="package_dimension_shipping" />,
          resizable: true,
          width: 95,
          sortable: true,
        },
        {
          key: 'weight_shipping',
          name: <Translate value="package_weight_shipping" />,
          resizable: true,
          width: 95,
          sortable: true,
        },
        {
          key: 'ReceiveQuantity',
          name: <Translate value="receive_qty" />,
          resizable: true,
          width: 70,
          sortable: true,
        },
        {
          key: 'ReceiveTotalWeight',
          name: <Translate value="receive_wt" />,
          resizable: true,
          width: 70,
          sortable: true,
        },
      ]
      :
      [
        {
          key: 'ProductNum',
          name: <Translate value="product_num" />,
          resizable: true,
          sortable: true,
          width: 100,
        },
        {
          key: 'RefNum',
          name: <Translate value="sku" />,
          resizable: true,
          sortable: true,
          width: 70,
        },
        {
          key: 'Name',
          name: <Translate value="product_name" />,
          resizable: true,
          sortable: true,
          width: 250,
        },
        {
          key: 'Description',
          name: <Translate value="description" />,
          resizable: true,
          sortable: true,
          width: 200,
        },
        {
          key: 'expire_date',
          name: <Translate value="expire_date" />,
          resizable: true,
          sortable: true,
          width: 80,
        },
        {
          key: 'PackageType',
          name: <Translate value="pkg_type" />,
          resizable: true,
          width: 50,
          sortable: true,
        },
        {
          key: 'OrderQuantity',
          name: <Translate value="order_qty" />,
          resizable: true,
          width: 70,
          sortable: true,
        },
        {
          key: "total_box",
          name: <Translate value="total_box" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: "pc_box",
          name: <Translate value="pc_box" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: "pack",
          name: <Translate value="pack" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'OrderTotalNetWeight',
          name: <Translate value="order_wt" />,
          resizable: true,
          width: 70,
          sortable: true,
        },
        {
          key: 'currency_unit',
          name: <Translate value="order_unit_dollarsign" />,
          resizable: true,
          width: 100,
          sortable: true,
        },
        {
          key: 'currency_subtotal',
          name: <Translate value="order_total_dollarsign" />,
          resizable: true,
          width: 100,
          sortable: true,
        },
        {
          key: isPS ? 'dimension' : 'dimension_shipping',
          name: isPS ? 'DIM (in)' : <Translate value="package_dimension_shipping" />,
          resizable: true,
          width: 95,
          sortable: true,
        },
        {
          key: 'weight_shipping',
          name: <Translate value="package_weight_shipping" />,
          resizable: true,
          width: 95,
          sortable: true,
        },
        {
          key: 'ReceiveQuantity',
          name: <Translate value="receive_qty" />,
          resizable: true,
          width: 70,
          sortable: true,
        },
        {
          key: 'ReceiveTotalWeight',
          name: <Translate value="receive_wt" />,
          resizable: true,
          width: 70,
          sortable: true,
        },
      ]
    }

    if (isPS) {
      const indexWT = _.findIndex(columns, { key: "weight_shipping" });
      const cmCol = {
        key: "dimension_cm",
        name: "DIM (cm)",
        resizable: true,
        width: 95,
        sortable: true,
      };
      const mmCol = {
        key: "dimension_mm",
        name: "DIM (mm)",
        resizable: true,
        width: 95,
        sortable: true,
      };
      columns.splice(indexWT, 0, cmCol, mmCol);
    }

    if(isOCM) {
      const download = {
        key: 'PurchaseOrderLine_id',
        name: <Translate value="download" />,
        resizable: true,
        sortable: true,
        width: 100,
        getRowMetaData: row => row,
        formatter: (props) => {
          const token = localStorage.getItem('token');
          const url = `${ROOT_URL}v1/purchase/order/print_label/${props.dependentValues.purchase_order_id}/${props.value}?Bearer=${token}`
          return <a
            href={url}
            style={{
            textDecoration: 'underline'
          }}>Download</a>
        }
      };
      const ProductNumIndex = _.findIndex(columns, { key: 'ProductNum' });
      columns.splice(ProductNumIndex + 1, 0, download);
    }

    // React Table Purchase Order Details
    return (
      <Row>
        <Col xs={12}>
          <div className="recat-customizer" id="PurchaseOrderList-dataGrid2">
            <ReactDataGrid
              headerRowHeight={45}
              onGridSort={handleGridSort}
              onAddFilter={handleFilterChange}
              onClearFilters={onClearFilters}
              columns={columns}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              rowHeight={25}
              minHeight={tableHeight}
              onRowUpdated={this.handleRowUpdated}
              onRowSelect={onRowSelect}
            />
          </div>
        </Col>
      </Row>
    );
  }

  IFrameIsLoaded = () => {
    if (!this.state.PdfFrameLoaded) {
      const pdfFrame = window.frames.purchaseOrderPdf;
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ PdfFrameLoaded: true });
    }
  };

  IFrameIsLoadedNs = () => {
    if (!this.state.PdfFrameLoadedNs) {
      const pdfFrame = window.frames.purchaseOrderPdfNs;
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ PdfFrameLoadedNs: true });
    }
  }

  commercialInvoiceIFrameIsLoaded = () => {
    if (!this.state.commercialInvoicePdfFrameLoaded) {
      const pdfFrame = window.frames.commercialInvoicePdf;
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ commercialInvoicePdfFrameLoaded: true });
    }
  }

  packingListIFrameIsLoaded = () => {
    if (!this.state.packingListPdfFrameLoaded) {
      const pdfFrame = window.frames.packingListPdf;
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ packingListPdfFrameLoaded: true });
    }
  }

  renderTotal() {
    if(isGGI || isABBLE || isCCW) {
      let selectedOrderCount = 0;
      if (this.state.rows && this.state.selectedRows && this.state.selectedRows.length > 0) {
        selectedOrderCount = this.state.selectedRows.length;
      }
      return <Row style = {{marginTop: 20}}>
        <Col xs={12}>
          <div>
            <Col xs={4}>
              <div className="column_po">
                <label className="row-count">
                  <Translate value="total_orders" />:&nbsp;
                  <span className="font-color-orange" id="row-count-equation">
                  {`${this.state.rowsCount} - 
                  ${this.state.canceledOrders} = 
                  ${this.state.rowsCount - this.state.canceledOrders}`}
                  </span>
                </label>
                <label className="row-count" style={{marginTop: '0px'}}>
                  <Translate value="selected_orders" />:&nbsp;
                  <span className="font-color-orange" id="row-count-equation">
                    {selectedOrderCount}
                  </span>
                </label>
              </div>
            </Col>
            {(isGGI || isCCW) &&
              <Col xs={4}>
                <div className="column_po">
                  <label className="grand-total">
                    <span className="grand-total-label">
                      <Translate value="grand_total" />
                      :&nbsp;
                    </span>
                    <span className="font-color-grey" id="total-equation">
                      {`$${numberWithCommas(
                      (this.state.total || 0).toFixed(2))} - $${numberWithCommas(
                      (this.state.canceledTotal || 0).toFixed(2)
                      )} = $${numberWithCommas(
                      (this.state.total - this.state.canceledTotal).toFixed(2)
                      )}`}
                    </span>
                  </label>
                  <label className="grand-total" style={{ marginTop: '0px' }}>
                    <span className="grand-total-label">
                      <Translate value="total_weight" />:&nbsp;
                    </span>
                    <span className="font-color-grey" id="total-equation">
                      {`${numberWithCommas(
                      (this.state.totalNetWeight || 0).toFixed(2)
                      )} - ${numberWithCommas(
                      (this.state.totalCancelledNetWeight || 0).toFixed(2)
                      )} = ${numberWithCommas(
                      (this.state.totalNetWeight - this.state.totalCancelledNetWeight).toFixed(2)
                      )}`}
                    </span>
                  </label>
                  <label className="grand-total" style={{ marginTop: '0px' }}>
                    <span className="grand-total-label">
                      <Translate value="total_qty" />:&nbsp;
                    </span>
                    <span className="font-color-grey" id="total-equation">
                      {
                      `${this.state.totalQty} - ${this.state.totalCancelledQty} = ${
                        (this.state.totalQty - this.state.totalCancelledQty)
                        }`
                      }
                    </span>
                  </label>
                </div>
              </Col>
            }
            {
              isGGI &&
              <Col xs={4}>
                <div className="column_po">
                  <span>
                    <Translate value="msg_total_orders_equation" />
                  </span>
                  <span>
                    <Translate value="msg_grand_total_equation" />
                  </span>
                  <span>
                    <Translate value="msg_total_weight_equation" />
                  </span>
                  <span>
                    <Translate value="msg_total_qty_equation" />
                  </span>
                </div>
              </Col>
            }
          </div>
        </Col>
      </Row>
    }
    return null
  }

  renderIFrame() {
    if (this.props.purchaseOrderPdf) {
      const file = window.URL.createObjectURL(this.props.purchaseOrderPdf);
      return <iframe style={{ display: 'none' }} onLoad={this.IFrameIsLoaded} id="purchaseOrderPdf" name="purchaseOrderPdf" src={file} />;
    }
    return null;
  }

  renderIFrameNs() {
    if (this.props.purchaseOrderPdfNs) {
      const file = window.URL.createObjectURL(this.props.purchaseOrderPdfNs);
      return <iframe style={{ display: 'none' }} onLoad={this.IFrameIsLoadedNs} id="purchaseOrderPdfNs" name="purchaseOrderPdfNs" src={file} />;
    }
    return null;
  }

  renderCommercialInvoiceIFrame = () => {
    if (this.props.commercialInvoicePdf) {
      const file = window.URL.createObjectURL(this.props.commercialInvoicePdf);
      return <iframe style={{ display: 'none' }} onLoad={this.commercialInvoiceIFrameIsLoaded} id="commercialInvoicePdf" name="commercialInvoicePdf" src={file} />;
    }
    return null;
  }

  renderPackingListIFrame = () => {
    if (this.props.packingListPdf) {
      const file = window.URL.createObjectURL(this.props.packingListPdf);
      return <iframe style={{ display: 'none' }} onLoad={this.packingListIFrameIsLoaded} id="packingListPdf" name="packingListPdf" src={file} />;
    }
    return null;
  }

  renderPrint() {
    let purchaseOrder_ids = this.state.selectedRows && this.state.selectedRows.length === 1 && this.state.selectedRows[0].PurchaseOrder_id;
    if (isGFD || isOLG) {
      purchaseOrder_ids = this.state.selectedRows && this.state.selectedRows.map(row => row.PurchaseOrder_id).join(',');
    }
    return (
      <Button
        bsStyle="primary"
        className="btn btn-primary marginLeftStyle"
        disabled={this.props.requestingPurchaseOrderPdf || !purchaseOrder_ids || !checkPermission('print_purchase_order')}
        type="button"
        onClick={() => {
          this.props.printPurchaseOrder(purchaseOrder_ids);
        }}
      >
        <em className="fa fa-print" />
        <Translate value={(isLAP || isAPD) ? "download_po" : "print_po"} />
      </Button>
    );
  }

  renderPrintNs() {
    const purchaseOrder_id = this.state.selectedRows && this.state.selectedRows.length === 1 && this.state.selectedRows[0].PurchaseOrder_id;
    return (
      <Button
      bsStyle="primary"
      className=" btn btn-primary marginLeftStyle"
      disabled={this.props.requestingPurchaseOrderPdfNs || !purchaseOrder_id || !checkPermission('print_purchase_order')}
      onClick={() => {
        this.props.printPurchaseOrderNoSubtotals(purchaseOrder_id);
      }}
      >
        <em className="fa fa-print" />
        <Translate value={(isLAP || isAPD) ? "download_ns" : "print_ns"}/>
      </Button>
      )
  }

  renderPrintCommercialInvoice = () => {
    const disabled = !checkPermission('print_purchase_order') || this.props.requestingCommercialInvoicePdf || this.state.selectedRows.length === 0
    return (
      <Button
        bsStyle="primary"
        className="btn btn-primary marginLeftStyle"
        disabled={disabled}
        type="button"
        onClick={() => {
          this.setState({
            showTotalBoxesPrintDialog: true,
            totalBoxesDialogType: 'commercialInvoice'
          })
        }}
      >
        <em className="fa fa-print" />
        <Translate value="print_commercial_invoice" />
      </Button>
    );
  }

  renderPrintPackingList = () => {
    const disabled = !checkPermission('print_purchase_order') || this.props.requestingPackingListPdf || this.state.selectedRows.length === 0
    return (
      <Button
        bsStyle="primary"
        className="btn btn-primary marginLeftStyle"
        disabled={disabled}
        type="button"
        onClick={() => {
          this.setState({
            showTotalBoxesPrintDialog: true,
            totalBoxesDialogType: 'packingList'
          })
        }}
      >
        <em className="fa fa-print" />
        <Translate value="print_packing_list" />
      </Button>
    );
  }

  renderDuplicate() {
    // const purchaseOrder_id = this.state.selectedRows && this.state.selectedRows.length === 1 && this.state.selectedRows[0].PurchaseOrder_id;
    const purchaseOrder_num = this.state.selectedRows && this.state.selectedRows.length === 1 && this.state.selectedRows[0].PONum;

    return (
      <Button
      bsStyle="success"
      className=" btn btn-primary marginLeftStyle"
      disabled={!purchaseOrder_num}
      onClick={() => {
        axios.post(
          `${ROOT_URL}v1/purchase/copy_po/${purchaseOrder_num}`,
          null,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                "token"
              )}`,
            },
          },
        )
        .then(
          (res) => {
            alert("Duplicate PO Successful");
            this.refreshList();
          },
          (err) => {
            // this.refreshList();
            if (err.data) {
              alert(err.data);
            } else {
              alert("Server issue detected, please contact admin.");
            }
          }
        );
      }}
      >
        <em className="fa fa-plus" />
        <Translate value="duplicate"/>
      </Button>
      )
  }

  renderExportButton() {
    const { FromDate, ToDate } = this.state;
    const Days = this.state.days;
    const status = this.state.Status === 'all' ? '' : `&PurchaseStatus=${this.state.Status}`;
    const dateRange = Days || -1;
    const { fromDate, toDate } = toFromDates(dateRange, FromDate, ToDate);
    let exportUrl = `${ROOT_URL}v1/purchase/search/export/?IsRelocation=false&OrderDate__gte=${fromDate}&OrderDate__lte=${toDate}${status}&Bearer=${localStorage.getItem('token')}`;
    if(isGGI) {
      exportUrl = `${ROOT_URL}v1/purchase/search/export/?IsRelocation=${this.state.Type == 'IsRelocation'}&OrderDate__gte=${fromDate}&OrderDate__lte=${toDate}${status}&Bearer=${localStorage.getItem('token')}`;
      if(this.props.selectedCompany && this.props.selectedCompany.value && this.props.selectedWarehouse && this.props.selectedWarehouse.value) {
        exportUrl = exportUrl + `&Company_id=${this.props.selectedCompany.value}&warehouse_id=${this.props.selectedWarehouse.value}`
      }
      if(this.state.selectedRows.length > 0) {
        let t = [];
        this.state.selectedRows.map(item => {
          t.push(item.PurchaseOrder_id);
        })
        exportUrl = exportUrl + `&poListIds=${t.toString()}`
      }
    }
    const currentPurchaseReturnRows = this.state.selectedRows;
    const idsSelect = []
    if(currentPurchaseReturnRows.length){
      currentPurchaseReturnRows.map(item => {
        idsSelect.push(item.PurchaseOrder_id)
      })
    }
    const idsData = idsSelect.join(',');
    if(isVAK){
      let companyId = this.props.selectedCompany && this.props.selectedCompany.value
      exportUrl += `&company_id=${companyId}`
      if(currentPurchaseReturnRows.length){
        exportUrl = `${ROOT_URL}v1/purchase/search/export/${idsData}?IsRelocation=false&OrderDate__gte=${fromDate}&OrderDate__lte=${toDate}${status}&Bearer=${localStorage.getItem('token')}&company_id=${companyId}`;
      }
    }

    if (isSH || isAP) {
      exportUrl = `${ROOT_URL}v1/purchase/export_shipping_advice?Bearer=${localStorage.getItem('token')}`;
    }
    if ((isHO || isJRC) && idsData) {
      exportUrl += `&ids=${idsData}`
    }
    if (isGFD) {
      let companyId = this.props.selectedCompany && this.props.selectedCompany.value
      exportUrl += `&Company_id=${companyId}`
    }

    return (
      <Button bsStyle="success" className="export-to-excel" href={exportUrl} disabled={!checkPermission('print_purchase_order')}>
        <em className="fa fa-download" />
        <Translate value={(isSH || isAP) ? "sa_report" : "excel"}/>
      </Button>
    );
  }

  renderExportOpenButton() {
    const { FromDate, ToDate } = this.state;
    const Days = this.state.days;
    const status = this.state.Status === 'all' ? '' : `&PurchaseStatus=${this.state.Status}`;
    const dateRange = Days || -1;
    const { fromDate, toDate } = toFromDates(dateRange, FromDate, ToDate);

    const exportOpenUrl = `${ROOT_URL}v1/purchase/search/export_open/?IsRelocation=false&OrderDate__gte=${fromDate}&OrderDate__lte=${toDate}&Bearer=${localStorage.getItem('token')}`;

    return (
      <Button bsStyle="success" className="export-to-excel" href={exportOpenUrl} disabled={!checkPermission('print_purchase_order')}>
        <em className="fa fa-download" />
        <Translate value="excel_open" />
      </Button>
    );
  }

  setMergePOModalVsibility = (isMergePOModalVisible = false) => this.setState({ isMergePOModalVisible });
  handleMergePoSuccess = () => {
    this.refreshList(true);
    this.setMergePOModalVsibility();
  }
  setSplitPOModalVisibility = (isSplitPOModalVisible = false) => this.setState({ isSplitPOModalVisible });
  handleSplitPOSuccess = () => {
    this.refreshList(true);
    this.setSplitPOModalVisibility();
  }

  quoteConversion = () => {
    const { selectedRows } = this.state;
    const poIds = [];
    if (selectedRows) {
      selectedRows.forEach((po) => {
        poIds.push(po.id);
      });
    }

    this.props.quoteToPlaced(poIds).then(() => {
      this.setState({ setOrderLoading: false });
      this.refreshList();
    });
  };

  renderQuoteButton= () => {
    const { selectedRows } = this.state;
    let onlyQuote = true;
    selectedRows.map((r) => {
      if (r.PurchaseStatus !== "Quote") {
        onlyQuote = false;
      }
    });

    return (
      <SpinnerButton
        bsStyle="success"
        disabled={ !onlyQuote }
        translation={<Translate value="set_order" />}
        loading={this.state.setOrderLoading}
        onClick={() => {
          this.setState({ setOrderLoading: true });
          this.quoteConversion();
        }}
      />
    );
  }

  renderMergePOButton = () => {
    const { rows, selectedRows } = this.state;
    return (
      <Button bsStyle="primary" disabled={selectedRows.length < 2} onClick={() => this.setMergePOModalVsibility(true)}>
        {/* <em className="fa fa-merge" /> */}
        <Translate value="merge_po" />
      </Button>
    );
  }

  renderSplitePOButton = () => {
    if (!isOCM) return null;
    const { rows, selectedRows } = this.state;
    return (
      <Button bsStyle="primary" disabled={selectedRows.length !== 1} onClick={() => this.setSplitPOModalVisibility(true)}>
        {/* <em className="fa fa-merge" /> */}
        <Translate value="split_po" />
      </Button>
    )
  }

  renderExportSelectedButton() {
    const purchaseOrderIds = [];
    const { selectedRows } = this.state;
    if (selectedRows && selectedRows.length > 0) {
      selectedRows.map((row) => {
        purchaseOrderIds.push(row.PurchaseOrder_id);
      });
    }
    const exportUrl = `${ROOT_URL}v2/po-line-export/${purchaseOrderIds.join(",")}?Bearer=${localStorage.getItem("token")}`
    return (
      <Button bsStyle="success" className="export-to-excel" href={exportUrl} disabled={(!purchaseOrderIds || purchaseOrderIds.length < 1)}>
        <em className="fa fa-download" />
        <Translate value="excel_lines" />
      </Button>
    );
  }

  mergeAndRedirect = () => {
    const { orderIds } = this.state;
    this.props.mergePurchaseOrders(orderIds);
  }

  openMergeRequest = () => {
    this.setState({
      mergeModalOpen: true
    });
  }

  cancelMergeRequest = () => {
    this.setState({
      mergeModalOpen: false
    })
  }

  mergePurchaseRows = () => {
    const { selectedRows } = this.state;
    let validMerge = true;
    let orderIds = [];
    if (selectedRows && selectedRows.length) {
      selectedRows.map(row => {
        let r = row;
        if (r.PurchaseStatus === 'Pending' || r.PurchaseStatus === 'Open') {
        validMerge = false;
        } else {
          orderIds.push(r.PurchaseOrder_id)
        }
      });
      this.setState({
        orderIds,
        validMerge
      });
    }
  }

  renderMergeButton() {
    const { validMerge, orderIds, selectedRows } = this.state;
    return (
      <Button
        bsStyle="primary"
        disabled={!validMerge || orderIds.length === 0 || selectedRows.length < 2}
        onClick={this.openMergeRequest}
      >
        <em class="fa fa-compress" />
        <Translate value="merge" />
      </Button>
    )
  }

  openTrackingNoteModal = () => {
    this.setState({ showTrackingNoteModal: true });
  }

  closeTrackingNoteModal = () => {
    this.setState({ showTrackingNoteModal: false });
  }

  checkTrackingNoteDisable() {
    const { selectedRows } = this.state;
    if (selectedRows === null || selectedRows.length !== 1) {
      return true;
    } else {
      return false;
    }
  }

  closeTotalBoxesPrintDialog = () => {
    this.setState({ showTotalBoxesPrintDialog: false, totalBoxesDialogType: null});
  }

  handleTotalBoxesPrint = totalBoxes => {
    if(this.state.totalBoxesDialogType === 'packingList') {
      this.printPackingList(totalBoxes);
    }
    if(this.state.totalBoxesDialogType === 'commercialInvoice') {
      this.printCommercialInvoice(totalBoxes);
    }
  }

  printCommercialInvoice = totalBoxes => {
    if(!totalBoxes) {
      alert('Total boxes cannot be blank');
      return false;
    }
    const ids = this.state.selectedRows.map(row => row.container_num);
    this.props.printCommercialInvoicePdf(ids, totalBoxes);
    this.closeTotalBoxesPrintDialog();
  }

  printPackingList = (totalBoxes) => {
    if(!totalBoxes) {
      alert('Total boxes cannot be blank') ;
      return false;
    }
    const ids = this.state.selectedRows.map(row => row.container_num);
    this.props.printPackingListPdf(ids, totalBoxes);
    this.closeTotalBoxesPrintDialog();
  }

  renderTrackingNote() {
    return (
      <Button
      bsStyle="success"
      type="button"
      disabled={this.checkTrackingNoteDisable()}
      onClick={this.openTrackingNoteModal}
      >
        <Translate value='tracking_note' />
      </Button>
    );
  }

  renderApprovePO() {
    const { selectedRows } = this.state;
    let onlyPending = true;
    if (selectedRows) {
      selectedRows.map(r => {
        if (r.PurchaseStatus !== 'Pending') {
          onlyPending = false;
        }
      });
    }
    return (
      <Button
        bsStyle="success"
        type="button"
        disabled={!selectedRows || selectedRows.length < 1 || onlyPending === false}
        onClick={() => {
        this.submitApprovePO(selectedRows);
      }}
      >
        <Translate value="approve" />
      </Button>
    );
  }

  renderQuoteTemplateDownload = () => {
    if (!this.state.isPurchaseOrderQuote) return;
    return (
      <Button
        bsStyle="success"
        type="button"
        // href={`${ROOT_URL_V2}purchase/download_po_quote_template?Bearer=${localStorage.getItem('token')}`}
        // disabled={!selectedRows || selectedRows.length < 1 || onlyDraft === false}
        onClick={() => {
          axios({
            method: 'get',
            url: `${ROOT_URL_V2}purchase/download_po_quote_template?Bearer=${localStorage.getItem('token')}`,
          }).then(res => {
            window.location.assign(res.data.url)
          })
        // this.submitSetToDraft(selectedRows);
      }}
      >
        <Translate value="template_download" />
      </Button>
    );
  }

  renderSetToOpen = () => {
    if (!isGFD) return;
    if (this.state.isPurchaseOrderQuote) return;
    const { selectedRows } = this.state;
    let onlyDraft = true;
    if (selectedRows) {
      selectedRows.map(r => {
        if (r.PurchaseStatus !== 'Draft' && r.PurchaseStatus !== 'Quote') {
          onlyDraft = false;
        }
      });
    }
    return (
      <Button
        bsStyle="success"
        type="button"
        disabled={!selectedRows || selectedRows.length < 1 || onlyDraft === false}
        onClick={() => {
        this.submitSetToDraft(selectedRows);
      }}
      >
        <Translate value="set_placed" />
      </Button>
    );
  }

  renderSendEmailButton = () => {
    const { selectedRows } = this.state;
    return (
      <Button
        bsStyle="success"
        className="print-btn"
        disabled={selectedRows.length !== 1}
        type="button"
        onClick={() => {
          this.props.emailPO(selectedRows[0].PurchaseOrder_id);
        }}
      >
        <em className="fa fa-email" />
        <Translate value="email_po" />
      </Button>
    );
  }

  renderSendEmailButtonTemplate = () => {
    const { selectedRows } = this.state;
    // const salesOrder_id =
    //   this.state.selectedRows.length === 1 &&
    //   this.state.selectedRows[0].SalesOrder_id;

    return (
      <Button
        bsStyle="success"
        className="print-btn"
        disabled={selectedRows.length !== 1}
        type="button"
        onClick={() => {
          this.setState({
            emailSubjectTemplate: this.genSubjectTemplate(),
            emailContentTemplate: this.genContentTemplate(),
            emailContentModalVisibility: true,
            source: "PO",
          })
        }}
      >
        <Translate value={((isLAP || isAPD) || isGFD) ? "send_po" : "email_po"} />
      </Button>
    );
  }

  renderReceivePo = () => {
    const { selectedRows } = this.state;
    // const salesOrder_id =
    //   this.state.selectedRows.length === 1 &&
    //   this.state.selectedRows[0].SalesOrder_id;
    let currentReceive = {};
    if (selectedRows && selectedRows.length > 0) {
      currentReceive = selectedRows[0];
    }

    return (
      <Button
        bsStyle="success"
        className="print-btn"
        disabled={selectedRows.length !== 1}
        type="button"
        onClick={() => {
          this.props.resetCurrentReceive();
          this.props.selectReceive(currentReceive);
          this.context.router.push('/inventories/receive/'+currentReceive.PONum);
        }}
      >
        <Translate value="receive_po" />
      </Button>
    );
  }

  renderPOExportButton = () => {
    const { selectedRows } = this.state;
    const success = () => {
      // alert('success!');
      // this.refreshList();
    }
    const failed = (err = 'UNKNOWN') => {
      alert('failed', err);
    }

    const pks = selectedRows.map(r => r.id);

    return (
      <Button
        bsStyle="success"
        className="print-btn"
        // disabled={!selectedRows.length}
        type="button"
        onClick={() => {
          // this.props.emailPO(selectedRows[0].PurchaseOrder_id);
          // alert('Truckxing is working hard to impelement this feature!!!')
          // pass 0 when no select any order
          let id = (selectedRows.length === 0) ? [0] : pks;
          this.props.handlePoExportClick(id, success, failed);
        }}
      >
        {/* <em className="fa fa-email" /> */}
        <Translate value="po_template" />
      </Button>
    );
  }

  completeDropship() {
    const { selectedRows } = this.state;
    let purchaseOrder_id = selectedRows && selectedRows[0] && selectedRows[0].PurchaseOrder_id;

    let data = {pk: purchaseOrder_id};
    axios.post(
      `${ROOT_URL}v1/purchase/update_dropship_status/${selectedRows[0].PurchaseOrder_id}`,
      // `${ROOT_URL}v1/purchase/update_dropship_status`,
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
    .then(res => {
      alert("Set to Complete!");
      this.refreshList();
    }, (err) => {
      if (err.data) {
        alert(JSON.stringify(err.data));
      } else {
        alert("Server issue detected, please contact admin.");
      }
    });

  }

  openDuplicate() {
    let {vendorOptions} = this.state;

    vendorOptions = [];
    axios.get(
      `${VENDOR_URL}?Company_id=${this.props.selectedCompany && this.props.selectedCompany.value}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
    .then(res => {
      res && res.data && res.data.map((r,i) => {
        vendorOptions.push({label: r.Name, value: r.Vendor_id});
      });
      this.setState({ vendorOptions, selectedVendor: null });
    }, (err) => {
      if (err.data) {
        alert(err.data);
      } else {
        alert("Server issue detected, please contact admin.");
      }
    })
    this.setState({ duplicateOpen: true });
  }
  closeDuplicate() {
    this.setState({ duplicateOpen: false });
  }
  handleDropdownChange = ( target ) => {
    this.setState({
      selectedVendor: target,
    })
  }
  confirmDuplicate = () => {
    const { selectedRows, selectedVendor } = this.state;
    const { selectedCompany, selectedWarehouse } = this.props;

    let data = {
      vendor_id: selectedVendor && selectedVendor.value,
      company_id: selectedCompany && selectedCompany.value,
      warehouse_id: selectedWarehouse && selectedWarehouse.value,
    };
    axios.post(
      `${ROOT_URL}v1/purchase/duplicate_po/${selectedRows[0].PurchaseOrder_id}`,
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
    .then(res => {
      alert("PO Duplicated!");
      this.setState({duplicateOpen: false});
      this.refreshList();
    }, (err) => {
      if (err.data) {
        alert(err.data);
      } else {
        alert("Server issue detected, please contact admin.");
      }
    })

  }

  openSubmitImage() {
    this.setState({ submitImageOpen: true });
  }
  closeSubmitImage() {
    this.setState({ submitImageOpen: false });
  }

  openEditReceiving(poNum, poId) {
    this.setState({ editReceivingOpen: true, editReceivingPoNum: poNum, editReceivingPoId: poId });
  }
  closeEditReceiving() {
    this.setState({ editReceivingOpen: false, editReceivingPoNum: null, editReceivingPoId: null });
  }

  openManagePod() {
    this.fetchPod();
    this.setState({ managePodOpen: true });
  }
  closeManagePod() {
    this.setState({ managePodOpen: false });
  }
  fetchPod() {
    let {selectedRows, podImageRows} = this.state;
    podImageRows.rows = [];
    if (selectedRows && selectedRows.length > 0) {
      let url = isGFD ? `${ROOT_URL}v2/upload_purchase_order_file/${selectedRows[0].PurchaseOrder_id}?type=1` : `${ROOT_URL}v2/upload_images/${selectedRows[0].PurchaseOrder_id}?type=PO_POD`
      axios.get(
        url,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        },
      )
      .then(res => {
        // podImageRows.rows = res.data;
        res && res.data && res.data.map((r,i) => {
          podImageRows.rows.push({ImageURL2: r.ImageURL, ...r});
        });
        this.setState({podImageRows});
      }, (err) => {
        if (err.data) {
          alert(err.data);
        } else {
          alert("Server issue detected, please contact admin.");
        }
      })
    }
  }

  onDropPOD = (files) => {
    const {
      selectedRows
    } = this.state;
    // return;
    const formData = new FormData();
    formData.append('PODFile', files[0]);
    const success = () => {
      alert('success');
      this.refreshList();
    }
    const failed = () => {
      alert('failed');
    }
    this.props.uploadPOPOD(selectedRows[0].PurchaseOrder_id, formData, success, failed)
  }


  renderPOUpload = () => {
    if (isABBLE) {
      const handleUpload = (platform, formData) => {
        const success = () => {
          alert('success');
          this.refreshList();
        }
        const failed = () => {
          alert('failed')
        }
        axios({
          method: 'post',
          url:  `${ROOT_URL}v2/abble_import_order?platform=${platform}`,
          data: formData,
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        })
        .then(res => {
          success();
        })
        .catch(err => {
          failed();
        })
      }
      return (
        <div>
          <input
            ref='hayneedle_po_upload_ref'
            type='file'
            name='hayneedle'
            id="hayneedle_po_upload_ref"
            onChange={(e) => {
              const files = e.target.files;
              const formData = new FormData();
              formData.append('FILE', files[0]);
              handleUpload('hayneedle', formData);
            }}
            style={{ display: 'none' }}
          />
          <input
            id="faire_po_upload_ref"
            ref='faire_po_upload_ref'
            type='file'
            name='faire'
            onChange={(e) => {
              const files = e.target.files;
              const formData = new FormData();
              formData.append('FILE', files[0]);
              handleUpload('faire', formData);
            }}
            style={{ display: 'none' }}
          />
          <DropdownButton
            bsStyle="success"
            // disabled={!this.props.currentSalesOrder}
            style={{ paddingLeft: '5px', marginLeft: '5px' }}
            className="upload_po"
            title={
              <span>
                <i className="fa fa-print" />
                <Translate value="upload_po" />
              </span>
            }
          >
            <MenuItem onClick={() => {
              this.refs.hayneedle_po_upload_ref.click();
            }}>
              <Translate value="hayneedle" />
            </MenuItem>
            <MenuItem onClick={() => {
              this.refs.faire_po_upload_ref.click();
            }}>
              <Translate value="faire" />
            </MenuItem>
        </DropdownButton>
        </div>
      )
    }

    const { selectedRows } = this.state;
    const success = () => {
      alert('success!');
      this.refreshList();
    }
    const failed = (err) => {
      if (err) {
        let mes = err.data || err;
        alert(JSON.stringify(mes));
        return;
      }
      alert('failed', err);
    }
    const pks = selectedRows.map(r => r.id);
    const onDrop = (files) => {
      if (this.state.isPurchaseOrderQuote) {
        const formData = new FormData();
        formData.append('file', files[0]);
        this.props.handlePOQuoteUpload(formData, success, failed, this.props.selectedCompany, this.props.selectedWarehouse);
        return;
      }
      const formData = new FormData();
      formData.append('FILE', files[0]);
      this.props.handlePOUpload(formData, success, failed, this.props.selectedCompany, this.props.selectedWarehouse);
    }
    return  (
      <Dropzone onDrop={onDrop} style={{ 'padding-left': '5px' }} className="upload-button">
        <Button
          bsStyle="success"
          className="print-btn"
          type="button"
          style={{ marginLeft: '5px' }}
        >
          {/* <em className="fa fa-email" /> */}
          <Translate value="upload_po" />
        </Button>
      </Dropzone>
    )
  }

  renderSetStatus = () => {
    const { selectedRows } = this.state;
    const success = () => {
      alert('success!');
      // this.refreshList();
    }
    const failed = (err) => {
      if (err) {
        let mes = err.data || err;
        alert(JSON.stringify(mes));
        return;
      }
      alert('failed', err);
    }

    return  (
      <DropdownButton
        className="status-dropdown"
        bsStyle="success"
        title={ <span> <Translate value="reset_status" /> </span> }
        disabled={
          !this.state.selectedRows ||
          this.state.selectedRows.length !== 1  ||
          this.state.selectedRows[0].order_status !== 'open'
        }
      >
        <MenuItem>
          <Button
            bsStyle="primary"
            className="btn btn-primary"
            type="button"
            onClick={() => { this.props.resetStatus('factory', this.state.selectedRows[0].id,  success, failed); }}
          >
            <Translate value="factory" />
          </Button>
        </MenuItem>
        <MenuItem>
          <Button
            bsStyle="primary"
            className="btn btn-primary"
            type="button"
            onClick={() => { this.props.resetStatus('port', this.state.selectedRows[0].id,  success, failed); }}
          >
            <Translate value="port" />
          </Button>
        </MenuItem>
        <MenuItem>
          <Button
            bsStyle="primary"
            className="btn btn-primary"
            type="button"
            onClick={() => { this.props.resetStatus('truck', this.state.selectedRows[0].id,  success, failed); }}
          >
            <Translate value="truck" />
          </Button>
        </MenuItem>
      </DropdownButton>
    )
  }

  setConvertToSOModalVisibility = (isConvertToSOModalVisible = false) => this.setState({ isConvertToSOModalVisible });

  renderOCMButtons = () => {
    let type = {
      IsRelocation: false,
      IsTransfer: false,
    };
    if (this.state.Type) {
      type[this.state.Type] = true;
    }

    const { FromDate, ToDate, days, Type, selectedRows } = this.state;
    const Days = days || -1;
    const { fromDate, toDate } = toFromDates(Days, FromDate, ToDate);
    const dateRangeParam = `&OrderDate__gte=${fromDate}&OrderDate__lte=${toDate}`;
    let orderTypeParam = '';
    if (Type) {
      orderTypeParam = `&${Type}=true`
    } else {
      orderTypeParam = `&IsTransfer=false&IsRelocation=false`;
    }

    const multi = `&Company_id=${this.props.selectedCompany && this.props.selectedCompany.value}&warehouse_id=${this.props.selectedWarehouse && this.props.selectedWarehouse.value}`;

    const poExportUrl = `${ROOT_URL}v1/purchase/export_po_lines?${dateRangeParam}${orderTypeParam}${multi}&Bearer=${localStorage.getItem('token')}`
    let linesExportUrl = 'javascript:;'
    if (selectedRows.length !== 0) {
      const pks = selectedRows.map(r => r.id);
      linesExportUrl = `${ROOT_URL}v1/purchase/export_po_line?pk=${pks.join(',')}&Bearer=${localStorage.getItem('token')}`
    }
    return(
      <div className="table-filters" style={{zIndex: 1, position: 'relative', padding: '5px 0px'}}>
        <ButtonToolbar className="table-buttons">
          <Button
            bsStyle="success"
            href={poExportUrl}
          >
            <Translate value="po_export" />
          </Button>
          <Button
            bsStyle="success"
            disabled={selectedRows.length !== 1}
            onClick={() => {
              this.setConvertToSOModalVisibility(true);
            }}
          >
            <Translate value="convert_to_so" />
          </Button>
          <Button
            bsStyle="success"
            disabled={selectedRows.length === 0}
            href={linesExportUrl}
          >
            <Translate value="export_po_lines" />
          </Button>
        </ButtonToolbar>
      </div>
    )
  }

  renderExportLines = () => {
    const { selectedRows } = this.state;

    let linesExportUrl = 'javascript:;'
    if (selectedRows.length !== 0) {
      const pks = selectedRows.map(r => r.id);
      linesExportUrl = `${ROOT_URL}v1/purchase/export_po_lines?pk=${pks.join(',')}&Bearer=${localStorage.getItem('token')}`
    }
    return(
      <Button
        bsStyle="success"
        disabled={selectedRows.length === 0}
        href={linesExportUrl}
      >
        <Translate value={isVAK ? "excel_details" : "excel_line_details"} />
      </Button>
    )
  }

  renderExportLinesGFD = () => {
    const { FromDate, ToDate, days, Type, selectedRows } = this.state;
    const handleExportClick = debounce(() => {
      const pks = selectedRows.map(r => r.id);
      const data = {};
      if(pks.length > 0) {
        data.pks = pks;
      }
      const Days = days || -1;
      const { fromDate, toDate } = toFromDates(Days, FromDate, ToDate);
      data.status = this.state.Status;
      data.OrderDate__gte = fromDate;
      data.OrderDate__lte = toDate;
      data.Company_id = this.props.selectedCompany && this.props.selectedCompany.value;
      data.warehouse_id = this.props.selectedWarehouse && this.props.selectedWarehouse.value;
      if (Type) {
        data[Type] = true;
      } else {
        data.IsTransfer = data.IsRelocation = false;
      }
      axios.post(
        `${ROOT_URL}v1/purchase/export_po_lines`,
        data,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          responseType: 'blob',
        },
      ).then((response) => {
        if (response.status === 200) {
          fileDownload(response.data, `PO_${moment().format('YYYYMMDD')}.xls`);
        }
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
        }
        alert(JSON.stringify(err.data));
      });
    }, 2000);
    return(
      <Button
        bsStyle="success"
        onClick={handleExportClick}
      >
        <Translate value={"excel_line_details"} />
      </Button>
    )
  }

  renderExportPoSV = () => {
    let type = {
      IsRelocation: false,
      IsTransfer: false,
    };
    if (this.state.Type) {
      type[this.state.Type] = true;
    }

    const { FromDate, ToDate, days, Type, selectedRows } = this.state;
    const Days = days || -1;
    const {
      fromDate, toDate
    } = toFromDates(Days, FromDate, ToDate);
    const dateRangeParam = `&OrderDate__gte=${fromDate}&OrderDate__lte=${toDate}`;
    let orderTypeParam = '';
    if (Type) {
      orderTypeParam = `&${Type}=true`
    } else {
      orderTypeParam = `&IsTransfer=false&IsRelocation=false`;
    }
    if (isSV) {
      orderTypeParam = '';
    }
    const multi = `&Company_id=${this.props.selectedCompany && this.props.selectedCompany.value}&warehouse_id=${this.props.selectedWarehouse && this.props.selectedWarehouse.value}`;

    let poExportUrl = '';
    let linesExportUrl = 'javascript:;'
    if (selectedRows.length !== 0) {
      const pks = selectedRows.map(r => r.id);
      poExportUrl = `${ROOT_URL}v1/purchase/export_po_line?${dateRangeParam}${orderTypeParam}${multi}&Bearer=${localStorage.getItem('token')}&pk=${pks.join(',')}`
      linesExportUrl = `${ROOT_URL}v1/purchase/export_po_lines?pk=${pks.join(',')}&Bearer=${localStorage.getItem('token')}`
    }
    return(
      <div className="table-filters" style={{zIndex: 1, position: 'relative', padding: '5px 0px'}}>
        <ButtonToolbar className="table-buttons">
          <Button
            bsStyle="success"
            disabled={selectedRows.length === 0}
            href={poExportUrl}
          >
            PO Export
          </Button>
          <Button
            bsStyle="success"
            disabled={selectedRows.length === 0}
            href={linesExportUrl}
          >
            PO Export Lines
          </Button>
          <Button
            bsStyle="success"
            disabled={selectedRows.length === 0}
            onClick={()=>{ this.openAddContainerNum(); }}
          >
            Add Container No.
          </Button>
        </ButtonToolbar>
      </div>
    )
  }

  renderAutoSuggest() {
    if (!this.state.filteredByItem) {
      return (
        <div className="control-dropdown">
          <GenericProductSuggest
            value={this.state.suggestValue}
            onChange={(e, { newValue }) => {
              this.setState({ suggestValue: newValue });
            }}
            SearchType={this.state.productSearchType}
            fetchOrdersByProduct={this.fetchPurchaseOrdersByProduct}
            fetchBy={isVAK ? 'RefNum' : undefined}
          />
        </div>
      );
    }
    return (
      <div className="control-dropdown" id="suggestion-box">
        {this.state.suggestValue}
        <em
          className="fa fa-times pull-right"
          onClick={() => {
            this.setState({ filteredByItem: false, suggestValue: '', filterProductID: null }, () => {
              this.fetchPurchaseOrdersByDetails(this.state.days);
            });
          }}
        />
      </div>
    );
  }

  searchPO = (order_num) => {
    this.refreshList();
  }

  searchPOByBoln = () => {
    let { selectedRows } = this.state;
    let newRows = this.state.rows;
    const fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
    const toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
    let { days } = this.state;
    if (days == null) {
      days = 7;
    }
    const shipFromDate = this.state.ShipFromDate ? this.formatDate(this.state.ShipFromDate) : '1900-01-01';
    const shipToDate = this.state.ShipToDate ? this.formatDate(this.state.ShipToDate) : '3000-01-01';

    let purchaser = this.props.Purchaser;
    if (this.props.Purchaser) {
      purchaser = this.props.Purchaser.value;
    }
    const productNum = this.props.ProductNum;
    if (isOCM) {
      this.state.currentPage = 0;
    }
    this.props.fetchPurchaseOrdersByFilter(
      this.context.router.routes[1].path,
      fromDate,
      toDate,
      days,
      this.state.Status,
      purchaser,
      productNum,
      shipFromDate,
      shipToDate,
      this.state.Type,
      null,
      this.state.productSearchType,
      this.state.suggestValue,
      undefined,
      this.state.limit,
      this.state.currentPage,
      this.getFilterParams(),
      isVAK,
    );

    setTimeout(() => {
      newRows = this.state.rows;
      if (newRows) {
        newRows.map((r, i)=>{
          selectedRows.map((s, j)=>{
            if (r.id === s.id) {
              selectedRows[j] = r;
              newRows[i].isSelected = true;
            }
          });
        });
      }
      this.setState({ ...this.state, selectedRows, rows: newRows});
    }, 1000);
  }

  searchPOByLoadingPort = () => {
    let { selectedRows } = this.state;
    let newRows = this.state.rows;
    const fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
    const toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
    let { days } = this.state;
    if (days == null) {
      days = 7;
    }
    const shipFromDate = this.state.ShipFromDate ? this.formatDate(this.state.ShipFromDate) : '1900-01-01';
    const shipToDate = this.state.ShipToDate ? this.formatDate(this.state.ShipToDate) : '3000-01-01';

    let purchaser = this.props.Purchaser;
    if (this.props.Purchaser) {
      purchaser = this.props.Purchaser.value;
    }
    const productNum = this.props.ProductNum;
    if (isOCM) {
      this.state.currentPage = 0;
    }
   this.props.fetchPurchaseOrdersByFilter(
     this.context.router.routes[1].path,
     fromDate,
     toDate,
     days,
     this.state.Status,
     purchaser,
     productNum,
     shipFromDate,
     shipToDate,
     this.state.Type,
     null,
     this.state.productSearchType,
     null,
     this.state.suggestValue,
     this.state.limit,
     this.state.currentPage,
     this.getFilterParams(),
     isVAK,
   );

    setTimeout(() => {
      newRows = this.state.rows;
      if (newRows) {
        newRows.map((r, i)=>{
          selectedRows.map((s, j)=>{
            if (r.id === s.id) {
              selectedRows[j] = r;
              newRows[i].isSelected = true;
            }
          });
        });
      }
      this.setState({ ...this.state, selectedRows, rows: newRows});
    }, 1000);
  }

  handleSetPo = (ids) => {
    const success = () => {
      this.refreshList();
    }
    const failed = (err) => {
      alert(err.message);
    }
    this.props.setPO(ids.toString(), success, failed)
  }

  renderPONoSearchInput = () => {
    return (
      <input
        placeholder="Purchase No."
        value={this.state.suggestValue}
        onChange={(e) =>
          this.setState({
            suggestValue: e.target.value,
          })
        }
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            this.searchPO(this.state.suggestValue);
          }
        }}
        style={{
          outline: "none",
          width: "100%",
          height: "24px",
          padding: "10px 10px",
          fontFamily: "Helvetica, sans-serif",
          fontWeight: "300",
          fontSize: "12px",
          border: "1px solid #aaa",
          borderRadius: "4px",
        }}
      />
    );
  };

  renderContainerNumSearchInput = () => {
    return (
      <input
        placeholder={I18n.t('Container Num.')}
        value={this.state.suggestValue}
        onChange={(e) =>
          this.setState({
            suggestValue: e.target.value,
          })
        }
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            this.refreshList();
          }
        }}
        style={{
          outline: "none",
          width: "100%",
          height: "24px",
          padding: "10px 10px",
          fontFamily: "Helvetica, sans-serif",
          fontWeight: "300",
          fontSize: "12px",
          border: "1px solid #aaa",
          borderRadius: "4px",
        }}
      />
    );
  };

  renderBolnSearchInput = () => {
    return (
      <input
        placeholder="Bill of Lading No."
        value={this.state.suggestValue}
        onChange={(e) =>
          this.setState({
            suggestValue: e.target.value,
          })
        }
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            this.searchPOByBoln(this.state.suggestValue);
          }
        }}
        style={{
          outline: "none",
          width: "100%",
          height: "24px",
          padding: "10px 10px",
          fontFamily: "Helvetica, sans-serif",
          fontWeight: "300",
          fontSize: "12px",
          border: "1px solid #aaa",
          borderRadius: "4px",
        }}
      />
    );
  }

  renderLoadingPortSearchInput = () => {
    return (
      <input
        placeholder="Loading Port"
        value={this.state.suggestValue}
        onChange={(e) =>
          this.setState({
            suggestValue: e.target.value,
          })
        }
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            this.searchPOByLoadingPort(this.state.suggestValue);
          }
        }}
        style={{
          outline: "none",
          width: "100%",
          height: "24px",
          padding: "10px 10px",
          fontFamily: "Helvetica, sans-serif",
          fontWeight: "300",
          fontSize: "12px",
          border: "1px solid #aaa",
          borderRadius: "4px",
        }}
      />
    );
  }

  renderOrderTypeRadio = () => {
    let config = {
      content: ((isEKC || isLMH || isBRO || isSDR || isCRW || isSC) && (this.context.router.routes[1].path === "dropshipOrder")) ? [
        {
          option: 'Open',
          id: 'open-radio-filter',
          name: 'typeFilterRadios',
          labelName: 'Pending',
        },
        {
          option: 'Complete',
          id: 'complete-radio-filter',
          name: 'typeFilterRadios',
          labelName: 'Ordered',
        },
      ] : [
        {
          option: null,
          id: 'normal-radio-filter',
          name: 'typeFilterRadios',
          labelName: 'normal',
        },
        {
          option: 'IsRelocation',
          id: 'relocate-radio-filter',
          name: 'typeFilterRadios',
          labelName: (isLAP || isAPD) ? 'transfer' : 'po_relocated',
        },
        ...isVAK ? [{
          option: 'IsProxy',
          id: 'proxy-radio-filter',
          name: 'typeFilterRadios',
          labelName: 'po_proxy',
        }] : []
      ],
      value: this.state.Type,
      handleOnClick: this.handleTypeFilterChange,
      type: 'buttons',
    }

    if(isGGI) {
      config.content.map(item=>{
        if(item.labelName == "po_relocated") {
          item.labelName = "transfer"
        }
      })
    }

    if (isOCM) {
      config.content.push({
        option: 'IsTransfer',
        id: 'transfer-radio-filter',
        name: 'typeFilterRadios',
        labelName: 'transfer',
      })
    }

    return (
      genericRadioFilter(config)
    )
  }

  renderOrderTypeFilter = () => {
    if (this.state.isPurchaseOrderQuote) return;
    return (<Col xs={12}>
      <Row>
        <Col xs={2}>
          <h3 className="filter-title">
            <Translate value="order_type" />
            <span className="colon">:</span>
          </h3>
        </Col>
        <Col xs={10}>
          <div id="statusFilterRadios" className="form-horizontal">
            {this.renderOrderTypeRadio()}
          </div>
        </Col>
      </Row>
    </Col>)
  }

  renderOrderStatusFilter = () => {
    if (this.state.isPurchaseOrderQuote) return;
    return (<Col xs={12}>
      <Row>
        <Col xs={2}>
          <h3 className="filter-title">
            <Translate value="order_status" />
            <span className="colon">:</span>
          </h3>
        </Col>
        <Col xs={10}>
          <div id="statusFilterRadios" className="form-horizontal">
            {genericRadioFilter({
              content: [
                {
                  option: 'all',
                  id: 'all-radio-filter',
                  name: 'statusFilterRadios',
                  labelName: 'all',
                },
                ...isVAK ? [{
                  option: 'Pending',
                  id: 'pending-radio-filter',
                  name: 'statusFilterRadios',
                  labelName: 'submit_pending',
                },
                {
                  option: 'Reviewing',
                  id: 'receiving-radio-filter',
                  name: 'statusFilterRadios',
                  labelName: 'reviewing',
                },
                {
                  option: 'Approving',
                  id: 'approving-radio-filter',
                  name: 'statusFilterRadios',
                  labelName: 'approving',
                }]:[],
                ...isCTP ? [{
                  option: 'Quote',
                  id: 'quote-radio-filter',
                  name: 'statusFilterRadios',
                  labelName: 'quote',
                }]:[],
                {
                  option: 'Placed',
                  id: 'placed-radio-filter',
                  name: 'statusFilterRadios',
                  labelName: isVAK ? 'receive_placed' : 'placed',
                },
                ...isABBLE ? [{
                  option: 'Departed',
                  id: 'departed-radio-filter',
                  name: 'statusFilterRadios',
                  labelName: 'departed',
                }] : [],
                ...isHMM ? [{
                  option: 'Factory',
                  id: 'factory-radio-filter',
                  name: 'statusFilterRadios',
                  labelName: 'factory',
                }, {
                  option: 'Port',
                  id: 'port-radio-filter',
                  name: 'statusFilterRadios',
                  labelName: 'port',
                }, {
                  option: 'Truck',
                  id: 'truck-radio-filter',
                  name: 'statusFilterRadios',
                  labelName: 'truck',
                }] : [],
                ...isVAK ? [{
                  option: 'Partially Received',
                  id: 'partial-received-radio-filter',
                  name: 'statusFilterRadios',
                  labelName: 'partial',
                }] : [],
                {
                  option: 'Received',
                  id: 'received-radio-filter',
                  name: 'statusFilterRadios',
                  labelName: 'received',
                },
                ...!isVAK ? [{
                  option: 'Partially Received',
                  id: 'partial-received-radio-filter',
                  name: 'statusFilterRadios',
                  labelName: 'partial',
                }] : [],
                {
                  option: 'Canceled',
                  id: 'canceled-received-radio-filter',
                  name: 'statusFilterRadios',
                  labelName: 'canceled',
                },
                ...(isLAP || isAPD) ? [{
                  option: 'Draft',
                  id: 'draft-received-radio-filter',
                  name: 'statusFilterRadios',
                  labelName: 'draft',
                },]:[],
              ],
              value: this.state.Status,
              handleOnClick: this.handleStatusFilterChange,
              type: 'buttons',
            })}
          </div>
        </Col>
      </Row>
    </Col>)
  }

  renderOrderDateFilter = () => {
    return (<Col xs={12}>
      <Row>
        <Col xs={2}>
          <h3 className="filter-title">
            <Translate value="order_date" />
            <span className="colon">:</span>
          </h3>
        </Col>
        <Col xs={10}>
          <div id="statusFilterRadios" className="form-horizontal">
            {dateFilterRadios({
              handleOnClick: this.fetchPurchaseOrdersByDetails,
              setToRangeSearch: this.setToRangeSearch,
              setFromDate: this.setFromDate,
              setToDate: this.setToDate,
              FromDate: this.state.FromDate,
              ToDate: this.state.ToDate,
              Days: this.state.days,
            })}
          </div>
        </Col>
      </Row>
    </Col>)
  }

  renderSearchInput = () => {
    const { productSearchType } = this.state
    if (this.state.productSearchType === 'order_num' || (isVAK && (productSearchType === 'PrNum' ||  productSearchType === 'MfgNum' || productSearchType === 'CommercialInvoice'))) {
      return <Col xs={12}>{this.renderPONoSearchInput()}</Col>
    }
    if (this.state.productSearchType === 'container_num') {
      return <Col xs={12}>{this.renderContainerNumSearchInput()}</Col>
    }
    if (this.state.productSearchType === 'boln') {
      return <Col xs={12}>{this.renderBolnSearchInput()}</Col>
    }
    if (this.state.productSearchType === 'LoadingPort') {
      return <Col xs={12}>{this.renderLoadingPortSearchInput()}</Col>
    }
    return <Col xs={12}>{this.renderAutoSuggest()}</Col>
  }

  renderMargeDraftPO = () => {
    if(!(isLAP || isAPD)) return null
    let disable = false;
    let rows = [...this.state.selectedRows];
    let ids = [];
    if(rows && rows.length > 0) {
      let firstRow = rows[0];
      rows.map(row => {
        if(row.PurchaseStatus != 'Draft') {
          disable = true;
          return
        }
        if(row.VendorID != firstRow.VendorID) {
          disable = true;
          return
        }
        ids.push(row.PurchaseOrder_id);
      })
    } else {
      disable = true;
    }
    return <Button
    bsStyle="success"
    type="submit"
    disabled={disable}
    onClick={()=>{this.handleSetPo(ids)}}
    >
      <Translate value="set_po" />
    </Button>
  }

  render() {
    const createDialogStyle = {
      width: '550px',
      height: '300px',
      marginLeft: '-15%',
    };
    const createTrackingNoteStyle = {
      width: '1012px',
      height: '500px',
      // marginLeft: '-15%',
    };
    const receivingStyle = {
      width: '1012px',
      height: '1000px',
      marginTop: '-450px'
    };
    const bolImageDialogue = {
      width: "700px",
      height: "600px",
      marginLeft: "-15%",
    };
    const managePodDialogue = {
      width: (isLAP || isAPD)  ? "300px" : isVAK ? "700px" : "500px",
      height: (isLAP || isAPD) ? "360px" : "600px",
      marginLeft: (isLAP || isAPD) ? "-5%" : "-15%",
      marginTop: isGFD ? '-350px' : '-200px'
    };
    const duplicateDialogue = {
      width: "500px",
      height: "200px",
      marginLeft: "-15%",
    };
    const trackingNoteTitle = (<Translate value="tracking_note" />);
    const packingListDialogTitle = <Translate value="print_packing_list_dialog"/>
    const { selectedRows } = this.state;
    let purchaseOrder_id = this.state.selectedRows && this.state.selectedRows[0] && this.state.selectedRows[0].PurchaseOrder_id;
    purchaseOrder_id = purchaseOrder_id || '';
    let breadcrumbTitle = (this.context.router.routes[1].path !== "dropshipOrder") ? "purchase_order" : "dropship_order"
    let detailTableTitle = (this.context.router.routes[1].path !== "dropshipOrder") ? "purchase_order_details" : "dropship_order_details";
    if (isSH || isAP) {
      breadcrumbTitle = 'shipping_advice';
      detailTableTitle = 'shipping_advice_details'
    }
    if (this.state.isPurchaseOrderQuote) {
      breadcrumbTitle = "purchase_order_quote"
    }

    return (
      //---------------
      // Begin HTML
      //---------------
      <ContentWrapper>
        {/* Nav Trail */}
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="purchase_management" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value={breadcrumbTitle} />
          </Breadcrumb.Item>
        </Breadcrumb>
        {/* End Nav Trail */}
        <Grid id="purchase-order-list">
          {/* Date Range Pickers */}
          <Row>
            <Col xs={12}>
              <Panel id="date-range-picker" className="form-horizontal">
                <Row>
                  {this.renderOrderTypeFilter()}
                  {this.renderOrderStatusFilter()}
                  {this.renderOrderDateFilter()}
                  {
                    isABBLE &&
                    <Col xs={2}>
                      <h3 className="filter-title">
                        <Translate value="ship_date" />
                        <span className="colon">:</span>
                      </h3>
                    </Col>
                  }
                  {isABBLE &&
                    <Col xs={10}>
                      <ButtonToolbar className="radio-filter-buttons">
                        <Button bsStyle="primary">
                          <label htmlFor="shipdateRange-radio-filter">
                            <DateTimePicker
                              id="from-datepicker1"
                              format="MM-DD-YY"
                              className="test-rw-input"
                              onChange={(e) => { this.setShipFromDate(e); }}
                              time={false}
                              placeholder={I18n.t("start")}
                              value={this.state.ShipFromDate}
                            />
                          </label>
                        </Button>
                        <Button bsStyle="primary">
                          <label htmlFor="shipdateRange-radio-filter">
                            <DateTimePicker
                              id="to-datepicker1"
                              format="MM-DD-YY"
                              className="test-rw-input"
                              onChange={(e) => { this.setShipToDate(e); }}
                              time={false}
                              placeholder={I18n.t("end")}
                              value={this.state.ShipToDate}
                            />
                          </label>
                        </Button>
                        <Button
                          className="search-button"
                          bsStyle="primary"
                          disabled={(!this.state.ShipFromDate || !this.state.ShipToDate)}
                          onClick={() => { this.fetchPurchaseOrdersByDetails() }}
                        >
                          <em className="fa fa-search" />
                        </Button>
                      </ButtonToolbar>
                    </Col>
                  }
                </Row>
              </Panel>
            </Col>
          </Row>
          {/* Purchase Order List */}
          <Row>
            <Col xs={12}>
              <Panel
                className="position-relative table-collapse-fix"
                id={isOCM ? 'table-collapse-fix-450' : (isGGI) ? 'table-collapse-fix-630':''}
                style={{height: (isVAK || isOLG) ? '435px' : (isSH || isAP || isCCW) ? 'auto' : '400px'}}
                >
                <div style={{ position: 'relative' }}>
                  <ButtonToolbar className="table-buttons">
                    <Button
                      bsStyle="success"
                      type="submit"
                      href={this.state.isPurchaseOrderQuote ? "/purchaseOrderQuote/new" : "/purchaseOrder/new"}
                      // onClick={(event) => { this.clickNew(event); }}
                      disabled={!checkPermission('add_purchase_order')}
                    >
                      <em className="fa fa-plus" />
                      <Translate value="create" />
                    </Button>
                    {
                      isTN && (
                        <Button
                          bsStyle="success"
                          // type="submit"
                          // href="/purchaseOrder/new"
                          onClick={(event) => {
                            this.refs.excelFileInputRef.click();
                          }}
                          disabled={!checkPermission('add_purchase_order')}
                        >
                          <em className="fa fa-plus" />
                          <Translate value="create_with_excel" />
                        </Button>
                      )
                    }
                    {
                      isTN && (
                        <input
                          type="file"
                          onChange={(e) => {
                            const formData = new FormData();
                            formData.append('FILE', e.target.files[0])
                            if (e.target.files[0]) {
                              axios.post(
                                `${ROOT_URL}v2/po-xls/`,
                                formData,
                                {
                                  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
                                },
                              )
                              .then(res => {
                                // this.fetchPurchaseOrdersByDetails(this.state.days)
                                alert("PO Imported Successfully");
                                this.refreshList();
                              }, (err) => {
                                if (err.data) {
                                  alert(err.data);
                                } else {
                                  alert("Server issue detected, please contact admin.");
                                }
                              })
                            }
                          }}
                          ref="excelFileInputRef"
                          name=""
                          id=""
                          style={{ display: 'none' }}
                        />
                      )
                    }
                    <Button
                      bsStyle="warning"
                      type="button"
                      href={this.state.isPurchaseOrderQuote ? `/purchaseOrderQuote/${purchaseOrder_id}` : `/purchaseOrder/${purchaseOrder_id}`}
                      // onClick={(event) => { this.setCurrentPurchaseOrder(event); }}
                      disabled={!this.state.selectedRows || this.state.selectedRows.length !== 1 || !checkPermission('change_purchase_order') || this.shouldEditButtonDisable()}
                    >
                      <em className="fa fa-pencil" />
                      <Translate value="edit" />
                    </Button>
                    {
                      isGFD &&
                      <Button
                        bsStyle="danger"
                        type="reset"
                        onClick={() => {
                          this.openCheckAuthorize('void');
                        }}
                        disabled={this.shouldVoidButtonDisableMulti() || !checkPermission('delete_purchase_order')}
                      >
                        <em className="fa fa-trash-o" />
                        <Translate value="void" />
                      </Button>
                    }
                    {
                      !isGFD &&
                    <Button
                      bsStyle="danger"
                      type="reset"
                      onClick={() => {
                        this.openCheckAuthorize('void');
                      }}
                      disabled={this.shouldVoidButtonDisable() || !checkPermission('delete_purchase_order')}
                    >
                      <em className="fa fa-trash-o" />
                      <Translate value="void" />
                    </Button>
                    }
                    {this.renderPrint()}
                    {!(isSH || isAP) && this.renderPrintNs()}
                    {isMMD && this.renderDuplicate()}
                    {!isGFD && this.renderExportButton()}
                    {(isEKC || isLMH || isBRO || isSDR || isCRW || isSC || isVAK) && this.renderExportLines()}
                    {isSV && this.renderExportOpenButton()}
                    {(isOCM || isGFD) && this.renderMergePOButton()}
                    {this.renderSplitePOButton()}
                    {isCTP && this.renderQuoteButton() }
                    {/* {this.renderPOUpload()} */}
                  </ButtonToolbar>
                  <div className="table-filters" style={{ zIndex: 99 }}>
                    <label className="control-label">
                      <Translate value="select_purchaser" />
                    </label>
                    {this.renderUsers()}
                    <ButtonToolbar className="table-buttons">
                      {(isTN || isAFG || isMMD) && this.renderExportSelectedButton()}
                      { isAFGRelated && this.renderMergeButton() }
                      {/* { isJML && this.renderTrackingNote()} */}
                      {!(isLMH || isBRO || isSDR || isCRW || isSC || isSH || isAP) && this.renderTrackingNote()}
                      {(isAFG || isMyuMyu || isMMD) && this.renderApprovePO()}
                      {(isOCM || isEKC || isLMH || isSDR || isCRW || isSC) && this.renderSendEmailButton()}
                      {(isSV || (isLAP || isAPD) || isGFD || isBRO) && this.renderSendEmailButtonTemplate()}
                      {!(isSH || isAP) && this.renderPOExportButton()}
                      {!(isSH || isAP) && this.renderPOUpload()}
                      {this.renderSetToOpen()}
                      {this.renderQuoteTemplateDownload()}
                      {(isLMH || isBRO || isSDR || isCRW || isSC) &&
                       <Button
                       bsStyle="success"
                       type="submit"
                       disabled={this.state.selectedRows.length !== 1}
                       onClick={() => this.openDuplicate()}
                     >
                       {/* <em className="fa fa-upload" /> */}
                       <Translate value="duplicate" />
                     </Button>
                      }
                      {(isLMH || isBRO || isSDR || isCRW || isSC) &&
                       <Button
                       bsStyle="success"
                       type="submit"
                       disabled={this.state.selectedRows.length !== 1}
                       onClick={() => this.completeDropship()}
                     >
                       {/* <em className="fa fa-upload" /> */}
                       <Translate value="complete" />
                     </Button>
                      }
                      {isHMM && this.renderSetStatus()}
                      {((isLAP || isAPD) || isOLG) && this.renderReceivePo()}
                      {
                        isVAK && (
                          <Button
                            bsStyle="success"
                            type="submit"
                            disabled={this.state.selectedRows.length !== 1}
                            onClick={() => this.openManagePod()}
                          >
                            <em className="fa fa-upload" />
                            <Translate value="upload_doc" />
                          </Button>
                        )
                      }
                      {isVAK && this.renderMergePOButton()}
                    </ButtonToolbar>
                  </div>

                  {
                    ((isLAP || isAPD) || isGFD) && (
                      <div className="table-filters-thirdrow" style={{ zIndex: 1 }}>
                      <ButtonToolbar style={{ position: 'relative', display: 'flex', flexDirection: 'row' }}>
                        {/* <Dropzone
                        // onDrop={this.onDropImage}
                        style={{ 'padding-left': '5px' }} className="upload-button">
                          <Button
                            bsStyle="success"
                            type="submit"
                            disabled={this.state.selectedRows.length !== 1}
                            onClick={() => this.openSubmitImage()}
                          >
                            <em className="fa fa-upload" />
                            <Translate value="upload_image" />
                          </Button>
                        </Dropzone> */}
                        {!isGFD && <Button
                          bsStyle="success"
                          type="submit"
                          disabled={this.state.selectedRows.length !== 1}
                          onClick={() => this.openSubmitImage()}
                        >
                          <em className="fa fa-upload" />
                          <Translate value="upload_image" />
                        </Button>}
                          {true &&
                            <Button
                              bsStyle="success"
                              type="submit"
                              disabled={this.state.selectedRows.length !== 1}
                              onClick={() => this.openManagePod()}
                            >
                              {/* <em className="fa fa-upload" /> */}
                              <Translate value={isGFD ? "upload_pod" : "manage_pod"} />
                            </Button>
                          }
                          {(isLAP || isAPD) && this.renderMargeDraftPO()}
                          {isGFD && this.renderExportButton()}
                          {isGFD && this.renderExportLinesGFD()}
                        {/* <Dropzone onDrop={this.onDropPOD} style={{ 'padding-left': '5px' }} className="upload-button">
                          <Button
                            bsStyle="success"
                            type="submit"
                            disabled={this.state.selectedRows.length !== 1}
                          >
                            <em className="fa fa-upload" />
                            <Translate value="upload_pod" />
                          </Button>
                        </Dropzone> */}
                      </ButtonToolbar>
                      </div>
                    )
                  }
                  {
                    false && (
                      <div className="table-filters-thirdrow" style={{ zIndex: 1 }}>
                      <ButtonToolbar style={{ position: 'relative', display: 'flex', flexDirection: 'row' }}>
                        <Button
                          bsStyle="success"
                          type="submit"
                          disabled={this.state.selectedRows.length !== 1}
                          onClick={() => this.openDuplicate()}
                        >
                          {/* <em className="fa fa-upload" /> */}
                          <Translate value="duplicate" />
                        </Button>
                      </ButtonToolbar>
                      </div>
                    )
                  }

{/* {
                    isGFD && (
                      <div className="table-filters-thirdrow" style={{ zIndex: 1 }}>
                      <ButtonToolbar style={{ position: 'relative', display: 'flex', flexDirection: 'row' }}>
                      {this.renderExportButton()}
                      {this.renderExportLines()}
                      </ButtonToolbar>
                      </div>
                    )
                  } */}




                  {isOCM && this.renderOCMButtons()}
                  {isSV && this.renderExportPoSV()}
                  {/*
                  {isSH && <div className="table-filters" style={{zIndex: 1, position: 'relative', padding: '5px 0px'}}>
                    <ButtonToolbar className="table-buttons">
                      {this.renderPrintCommercialInvoice()}
                      {this.renderPrintPackingList()}
                    </ButtonToolbar>
                  </div>}
                  */}
                  <div id="autosuggest-div">
                    <Row style={{ height: '30px' }}>
                      <Col xs={isOCM ? 12 : 9}>
                        <TypeRadios value={this.state.productSearchType} handleOptionChange={this.handleOptionChange} SalesOrderNoSearch BillOfLadingSearch={isSH || isAP} loadingPortSearch={isABBLE} containerNum={isOCM} productNumSearch={isVAK} mfgNumSearch={isVAK} cInvoiceSearch={isVAK}/>
                      </Col>
                      {/* <Col>
                        <span style={{ fontSize: '13px', fontWeight: 'bold', paddingLeft: '30px', paddingRight: '10px' }}><Translate value='relocated_order'/></span><input type='checkbox' checked={this.state.isSearchingRelocated} onChange={this.handleRelocatedSearchCheckClick}/>
                      </Col> */}
                    </Row>
                    <Row>
                      <Col xs={(isOCM || isVAK) ? 7 : 6}>
                        <Row>
                          {
                            this.renderSearchInput()
                          }
                        </Row>
                      </Col>
                    </Row>
                  </div>
                </div>
                {/* Purchase Order Full Table */}
                {this.renderTable()}
              </Panel>
            </Col>
          </Row>
          {/* End Purchase Order List */}
          {/* Purchase Order Details */}
          <Row>
            <Col xs={12}>
              <h2>
                <Translate value={detailTableTitle} />
              </h2>
              <Panel className={(isSH || isAP) ? '' : 'details-table-collapse-fix'}>
                {this.renderProductsTable()}
              </Panel>
            </Col>
          </Row>
          {this.renderIFrame()}
          {this.renderIFrameNs()}
          {this.renderCommercialInvoiceIFrame()}
          {this.renderPackingListIFrame()}
        </Grid>
        <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.checkAuthorizeOpen} onCloseClicked={this.closeCheckAuthorize}>
          <ConfirmActionModal case="confirmPassword" closeC={this.checkAuthorize} checkPasswordFailure={this.props.checkPasswordFailure} />
        </SkyLightStateless>

        <SkyLightStateless
          dialogStyles={duplicateDialogue}
          isVisible={this.state.containerNumOpen}
          onCloseClicked={() => {
            this.closeAddContainerNum();
          }}
          title={"Add Container No."}
        >
          <Row>
            <Col sm={4}>
              <label><Translate value="container_no" /></label>
            </Col>
          </Row>
          <Row>
            <Col sm={4}>
              <Input type="text" value={this.state.containerNum} onChange={this.onChangeContainerNum} />
            </Col>
          </Row>
          <br />
          <ButtonToolbar className="button-toolbar-center">
            <Button
              bsStyle="success"
              onClick={this.confirmContainerNum}
              type="button"
            >
              <Translate value="confirm" />
            </Button>
          </ButtonToolbar>
        </SkyLightStateless>

        <SkyLightStateless
          dialogStyles={createTrackingNoteStyle}
          isVisible={this.state.showTrackingNoteModal}
          onCloseClicked={this.closeTrackingNoteModal}
          onOverlayClicked={this.closeTrackingNoteModal}
          title={trackingNoteTitle}
        >
          <TrackingNoteModal
            selectedOrder={selectedRows}
          />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.showTotalBoxesPrintDialog}
          onCloseClicked={this.closeTotalBoxesPrintDialog}
          onOverlayClicked={this.closeTotalBoxesPrintDialog}
          title={packingListDialogTitle}
        >
          <ConfirmActionModal case="inputTotalBoxes" closeC={this.handleTotalBoxesPrint} />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createDialogStyle}
          onCloseClicked={this.cancelMergeRequest}
          onOverlayClicked={this.cancelMergeRequest}
          isVisible={this.state.mergeModalOpen}
        >
          <Row className="centerStyle"><h4><Translate value="msg_confirm_merge_pos" /></h4></Row>
          <br /><br /><br/>
          <Row className="centerStyle">
            <Button bsStyle="primary" className="mr" onClick={this.mergeAndRedirect} type="button" ><Translate value="yes" /></Button>
            <Button bsStyle="danger" className="mr" onClick={ this.cancelMergeRequest} type="button" ><Translate value="no" /></Button>
          </Row>
        </SkyLightStateless>

        <SkyLightStateless
          dialogStyles={duplicateDialogue}
          isVisible={this.state.duplicateOpen}
          onCloseClicked={() => { this.closeDuplicate(); }}
          title={<Translate value="duplicate_purchase_order" />}
        >
          {/* <Row className="centerStyle"><h4><Translate value="msg_confirm_duplicate" /></h4></Row> */}
          {/* <br /><br /><br/> */}
          <Row className="centerStyle">
            <div style={{marginBottom: '3px', fontSize: '14px', fontWeight: 'bold'}}>Select Vendor: </div>
          <div className="email365" style={{ marginBottom: '13px'}}>
            <GenericSelection
              options={this.state.vendorOptions}
              value={this.state.selectedVendor}
              setSelected={(e) => {this.handleDropdownChange(e)}}
            />
          </div>
          </Row>
          <Row className="centerStyle">
            <Button bsStyle="primary" className="mr" disabled={!this.state.selectedVendor} onClick={this.confirmDuplicate} type="button" ><Translate value="confirm" /></Button>
            <Button bsStyle="danger" className="mr" onClick={()=> this.closeDuplicate()} type="button" ><Translate value="cancel" /></Button>
          </Row>
        </SkyLightStateless>

        <SkyLightStateless
          dialogStyles={bolImageDialogue}
          isVisible={this.state.submitImageOpen}
          onCloseClicked={() => { this.closeSubmitImage(); }}
          title={<Translate value="submit_image" />}
        >
          <BolImagesTablePO
            poid={this.state.selectedRows.length === 1 &&
              this.state.selectedRows[0].PurchaseOrder_id}
            handleImageClosed={() => { this.closeSubmitImage(); }}
          />
        </SkyLightStateless>

        <SkyLightStateless
          dialogStyles={receivingStyle}
          isVisible={this.state.editReceivingOpen}
          onCloseClicked={() => { this.closeEditReceiving(); }}
          title={<Translate value="receiving_detail" />}
        >
          <ReceivingTable
            poNum={this.state.editReceivingPoNum}
            poId={this.state.editReceivingPoId}
            warehouse={this.props.selectedWarehouse}
            handleClosed={() => { this.closeEditReceiving(); }}
          />
        </SkyLightStateless>

        <SkyLightStateless
          dialogStyles={managePodDialogue}
          isVisible={this.state.managePodOpen}
          onCloseClicked={() => { this.closeManagePod(); }}
          title={!isVAK ? <Translate value={isGFD ? "upload_pod" : "manage_pod"} /> : <Translate value="upload_doc" />}
        >
          <div className="toolbar-row" style={{marginBottom: '10px'}}>
            <ButtonToolbar>
              {this.renderPodUpload()}
              {this.renderPodDelete()}
            </ButtonToolbar>
          </div>
          {this.renderPodTable()}
        </SkyLightStateless>

        <MergePOModal
          isVisible={this.state.isMergePOModalVisible}
          onClose={this.setMergePOModalVsibility}
          onConfirm={this.setMergePOModalVsibility}
          selectedRows={this.state.selectedRows}
          handleMergePoSuccess={this.handleMergePoSuccess}
        />
        <SplitPOModal
          isVisible={this.state.isSplitPOModalVisible}
          onClose={this.setSplitPOModalVisibility}
          selectedRows={this.state.selectedRows}
          handleSplitPOSuccess={this.handleSplitPOSuccess}
        />
        <ConvertToSOModal
          isVisible={this.state.isConvertToSOModalVisible}
          setVisibility={this.setConvertToSOModalVisibility}
          selectedRows={this.state.selectedRows}
          fetchCustomers={this.props.fetchCustomers}
          customers={this.props.customers}
          selectedCompany={this.props.selectedCompany}
          fetchSalesCustomerDetail={this.props.fetchSalesCustomerDetail}
          salesShippingCustomerDetails={this.props.salesShippingCustomerDetails}
          selectedWarehouse={this.props.selectedWarehouse}
        />
        <EmailContentModal
          visible={this.state.emailContentModalVisibility}
          subject={this.state.emailSubjectTemplate}
          content={this.state.emailContentTemplate}
          onConfirm={this.handleEmailContentConfirm}
          onClose={this.handleEmailContentClose}
          selectedRows={this.state.selectedRows}
          source={'PO'}
        />
      </ContentWrapper>
      //---------------
      // End HTML: Purchase Order List
      //---------------
    );
  }
}

PurchaseOrderList.propTypes = propTypes;
export default PurchaseOrderList;



// WEBPACK FOOTER //
// ./master/jsx/components/Purchase/purchaseOrderList.jsx